







// // import React, { useEffect, useState } from "react";
// // import { Card, Checkbox, Radio, Divider, Badge, Tooltip, Spin, Alert, Steps, Button, Modal, List, Tag, Progress } from "antd";
// // import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
// // import courseService from "../../services/course.service";
// // import MatchingQuestionViewer from "./MatchingQuestionViewer";
// // import { CheckCircleTwoTone, FileTextOutlined, InfoCircleTwoTone, CloseCircleTwoTone, ClockCircleOutlined, TrophyOutlined, BookOutlined } from '@ant-design/icons';
// // import { useDispatch } from "react-redux";
// // import { recalculateNote } from "../../actions/noteActions";
// // import DragDropZones from '../moderateur/quizes/DragDropZones';
// // // import DragDropImage from '../moderateur/quizes/drag_drop_images/DragDropImage';
// // import DragDropImage from '../moderateur/quizes/drag_drop_images/DragDropImage';


// // const { Step } = Steps;

// // const TestDeConnaissance = ({ quizId, courseId, attemptOnce = false }) => {
// //   const dispatch = useDispatch();

// //   // ✅ TOUS LES STATES
// //   const [quiz, setQuiz] = useState(null);
// //   const [showIntroduction, setShowIntroduction] = useState(true);
// //   const [questions, setQuestions] = useState([]);
// //   const [loading, setLoading] = useState(true);
// //   const [error, setError] = useState(null);
// //   const [userAnswers, setUserAnswers] = useState({});
// //   const [submitted, setSubmitted] = useState(false);
// //   const [currentStep, setCurrentStep] = useState(0);
// //   const [threshold, setThreshold] = useState(0);
// //   const [isGeneratingBadge, setIsGeneratingBadge] = useState(false);
// //   const [downloading, setDownloading] = useState(false);
// //   const [reviewResults, setReviewResults] = useState([]);
// //   const [showSummaryModal, setShowSummaryModal] = useState(false);
// //   const [score, setScore] = useState(0);
// //   const [myscore_stored, setmyscore_stored] = useState(0);
// //   const [resultSaved, setResultSaved] = useState(false);
// //   const [submitting, setSubmitting] = useState(false);
// //   const [progress, setProgress] = useState([]);
// //   const [refreshTrigger, setRefreshTrigger] = useState(0);

// //   // ✅ VARIABLES CALCULÉES
// //   const totalPossibleScore = questions.reduce((sum, q) => sum + (q.score || 0), 0);
// //   const isAttemptOnce = attemptOnce === true || attemptOnce === 1;
// //   const storedUser = JSON.parse(localStorage.getItem("user"));
// //   const userId = storedUser?.id || null;

// //   // ✅ FONCTIONS UTILITAIRES
// //   const shuffleArray = (array) => {
// //     const shuffled = [...array];
// //     for (let i = shuffled.length - 1; i > 0; i--) {
// //       const j = Math.floor(Math.random() * (i + 1));
// //       [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
// //     }
// //     return shuffled;
// //   };

// //   const isValidHtml = (html) => {
// //     const div = document.createElement("div");
// //     div.innerHTML = html;
// //     return div.textContent.trim().length > 0;
// //   };

// //   const calculateScore = () => {
// //     if (!submitted) return 0;
// //     return questions.reduce((sum, q) => isCorrect(q) ? sum + (q.score || 0) : sum, 0);
// //   };

// //   const isCorrect = (question) => {
// //     const userAnswer = userAnswers[question.id];

// //     if (question.questionType === "MATCHING") {
// //       if (!userAnswer) return false;
// //       return question.options.every(
// //         (pair) => userAnswer[pair.leftText] === pair.rightText
// //       );
// //     }

// //     // ✅ CORRECT - Retourne true/false
// //     if (question.questionType === "DRAG_DROP_IMAGE") {
// //       if (!userAnswer || typeof userAnswer !== 'object') return false;
// //       const zones = question.imageZones || [];
// //       return zones.every((zone) => {
// //         return userAnswer[zone.id.toString()] === zone.correctAnswer;
// //       });
// //     }

// //     // ✅ CORRECT
// //     if (question.questionType === "DRAG_DROP_ZONES") {
// //       if (!userAnswer || typeof userAnswer !== 'object') return false;
// //       const zones = question.zones || [];
// //       return zones.every((zone) => {
// //         return userAnswer[zone.id.toString()] === zone.correctAnswer;
// //       });
// //     }

// //     const correct = question.correctAnswers;
// //     if (Array.isArray(userAnswer)) {
// //       return JSON.stringify(userAnswer.sort()) === JSON.stringify(correct.sort());
// //     }
// //     return userAnswer === correct[0];
// //   };



// //   const handleStartQuiz = () => {
// //     console.log("🚀 Démarrage du quiz - Masquage de l'introduction");
// //     setShowIntroduction(false);
// //   };


// //   // // ✅ AJOUTER TOUT CE BLOC ICI
// //   // useEffect(() => {
// //   //   const loadQuizInfo = async () => {
// //   //     try {
// //   //       console.log("📋 Chargement des infos du quiz ID:", quizId);
// //   //       const quizData = await courseService.getQuizByIdWithIntro(quizId);
// //   //       console.log("✅ Quiz chargé:", quizData);
// //   //       console.log("📝 Introduction Text:", quizData?.introductionText);
// //   //       setQuiz(quizData);

// //   //       await checkExistingSubmission();

// //   //     } catch (error) {
// //   //       console.error("❌ Erreur lors du chargement du quiz :", error);
// //   //       setError("Erreur lors du chargement du quiz.");
// //   //     }
// //   //   };

// //   //   if (quizId) {
// //   //     loadQuizInfo();
// //   //   }
// //   // }, [quizId]);

// // // ✅ REMETTRE CE BLOC (il était commenté)
// // useEffect(() => {
// //     const loadQuizInfo = async () => {
// //       try {
// //         console.log("📋 Chargement des infos du quiz ID:", quizId);
// //         const quizData = await courseService.getQuizByIdWithIntro(quizId);
// //         console.log("✅ Quiz chargé:", quizData);
// //         setQuiz(quizData);
// //         await checkExistingSubmission();
// //       } catch (error) {
// //         console.error("❌ Erreur lors du chargement du quiz :", error);
// //         setError("Erreur lors du chargement du quiz.");
// //       }
// //     };

// //     if (quizId) {
// //       loadQuizInfo();
// //     }
// //   }, [quizId]);

// //   useEffect(() => {
// //     const loadQuiz = async () => {
// //       if (!quiz) return;

// //       try {
// //         console.log("📝 Chargement optimisé des questions du quiz:", quizId);
// //         const questionList = await courseService.getQuestionsWithAnswers(quizId);

// //         const questionsWithOptions = questionList.map((question) => {
// //           if (question.questionType === "MATCHING") {
// //             return { ...question, options: question.matchingPairs || [] };
// //           }
// //           else if (question.questionType === "DRAG_DROP_ZONES") {
// //             return {
// //               ...question,
// //               zones: question.zones || [],
// //               propositions: question.propositions || []
// //             };
// //           }
// //           else if (question.questionType === "DRAG_DROP_IMAGE") {
// //             return {
// //               ...question,
// //               imageZones: question.imageZones || [],
// //               propositions: question.propositions || []
// //             };
// //           }
// //           else {
// //             const options = question.answers || [];
// //             const correctAnswers = options.filter(opt => opt.isCorrect || opt.correct).map(opt => opt.text);
// //             const shuffledOptions = question.questionType === "DRAG_DROP" ? shuffleArray(options) : options;
// //             return { ...question, options: shuffledOptions, correctAnswers };
// //           }
// //         });

// //         setQuestions(questionsWithOptions);
// //         console.log("✅ Questions traitées (optimisé):", questionsWithOptions.length);
// //       } catch (err) {
// //         console.error("Erreur chargement quiz:", err);
// //         setError("Erreur lors du chargement du quiz.");
// //       } finally {
// //         setLoading(false);
// //       }
// //     };

// //     loadQuiz();
// //   }, [quiz, quizId]);

// // // 3️⃣ Lazy load des images (celui que tu as ajouté)
// // useEffect(() => {
// //     const loadImageIfNeeded = async () => {
// //       if (!questions.length) return;
// //       const currentQ = questions[currentStep];
      
// //       if (currentQ?.questionType === "DRAG_DROP_IMAGE" && !currentQ.imageLoaded) {
// //         try {
// //           console.log("🖼️ Lazy loading images pour question:", currentQ.id);
// //           const imageData = await courseService.getQuestionImageData(currentQ.id);
          
// //           setQuestions(prev => prev.map((q, idx) => 
// //             idx === currentStep 
// //               ? { ...q, imageZones: imageData.imageZones, propositions: imageData.propositions, imageUrl: imageData.imageUrl, imageLoaded: true }
// //               : q
// //           ));
// //           console.log("✅ Images chargées pour question:", currentQ.id);
// //         } catch (err) {
// //           console.error("❌ Erreur chargement images:", err);
// //         }
// //       }
// //     };
// //     loadImageIfNeeded();
// // }, [currentStep, questions.length]);

// //   const checkExistingSubmission = async () => {
// //     try {
// //       const user = JSON.parse(localStorage.getItem("user"));
// //       console.log("🔍 Vérification soumission existante pour userId:", user.id, "quizId:", quizId);

// //       const review = await courseService.getQuizReviewResults(user.id, quizId);
// //       console.log("📦 Review reçue:", review);

// //       if (review && review.length > 0) {
// //         console.log("⚠️ Quiz déjà soumis - Passage direct aux résultats");
// //         const reconstructedAnswers = {};

// //         review.forEach((question) => {
// //           const type = question.questionType;
// //           console.log(`📝 Reconstruction pour question ${question.questionId} - Type: ${type}`);

// //           if (type === "QCU" || type === "VRAI_FAUX") {
// //             reconstructedAnswers[question.questionId] = question.userAnswers[0]?.text || "";
// //           }
// //           else if (type === "QCM") {
// //             reconstructedAnswers[question.questionId] = question.userAnswers.map(a => a.text);
// //           }
// //           else if (type === "MATCHING") {
// //             const map = {};
// //             question.userAnswers.forEach((a) => {
// //               map[a.leftText] = a.rightText;
// //             });
// //             reconstructedAnswers[question.questionId] = map;
// //           }
// //           else if (type === "DRAG_DROP_IMAGE") {
// //             const imageZoneAnswers = {};

// //             if (question.imageZoneAnswers && Array.isArray(question.imageZoneAnswers)) {
// //               console.log(`   🖼️ ${question.imageZoneAnswers.length} zones image trouvées`);
// //               question.imageZoneAnswers.forEach((zone) => {
// //                 const zoneId = zone.imageZoneId;
// //                 const userAnswer = zone.userAnswer;

// //                 if (zoneId !== null && zoneId !== undefined) {
// //                   imageZoneAnswers[zoneId.toString()] = userAnswer;
// //                   console.log(`   ✅ Zone image ${zoneId}: ${userAnswer}`);
// //                 }
// //               });
// //             }

// //             reconstructedAnswers[question.questionId] = imageZoneAnswers;
// //             console.log(`   ✅ Réponses image reconstruites:`, imageZoneAnswers);
// //           }
// //           else if (type === "DRAG_DROP_ZONES") {
// //             const zoneAnswers = {};

// //             if (question.zoneAnswers && Array.isArray(question.zoneAnswers)) {
// //               console.log(`   🎯 ${question.zoneAnswers.length} zones trouvées`);
// //               question.zoneAnswers.forEach((zone) => {
// //                 if (zone.zoneId !== null && zone.zoneId !== undefined) {
// //                   zoneAnswers[zone.zoneId.toString()] = zone.userAnswer;
// //                   console.log(`   Zone ${zone.zoneId}: ${zone.userAnswer}`);
// //                 }
// //               });
// //             }

// //             reconstructedAnswers[question.questionId] = zoneAnswers;
// //             console.log(`   ✅ Réponses reconstruites:`, zoneAnswers);
// //           }
// //           // 🆕 AJOUTER CE BLOC POUR DRAG_DROP
// //           else if (type === "DRAG_DROP") {
// //             if (question.userAnswers && Array.isArray(question.userAnswers)) {
// //               console.log(`   📋 ${question.userAnswers.length} réponses DRAG_DROP trouvées`);

// //               // ✅ Reconstruire le tableau dans l'ordre (ordre = index dans le tableau)
// //               const orderedAnswers = question.userAnswers.map(answer => answer.text);

// //               reconstructedAnswers[question.questionId] = orderedAnswers;
// //               console.log(`   ✅ Réponses DRAG_DROP reconstruites:`, orderedAnswers);
// //             } else {
// //               console.error(`   ❌ userAnswers manquant pour DRAG_DROP`);
// //               reconstructedAnswers[question.questionId] = [];
// //             }
// //           }
// //         });

// //         console.log("📊 Toutes les réponses reconstruites:", reconstructedAnswers);

// //         setUserAnswers(reconstructedAnswers);
// //         setSubmitted(true);
// //         setResultSaved(true);
// //         setShowIntroduction(false);

// //         console.log("✅ États mis à jour - showIntroduction=false, submitted=true");
// //       } else {
// //         console.log("ℹ️ Review vide - Aucune soumission existante");
// //       }
// //     } catch (error) {
// //       console.error("❌ Erreur dans checkExistingSubmission:", error);
// //       console.error("Stack:", error.stack);
// //       if (error.response?.status !== 404) {
// //         console.error("Response:", error.response?.data);
// //       }
// //     }
// //   };

// //   useEffect(() => {
// //     const loadThreshold = async () => {
// //       try {
// //         if (!courseId) {
// //           console.warn("❗ courseId manquant pour récupération du seuil");
// //           return;
// //         }
// //         const fetchedThreshold = await courseService.getThreshold(courseId);
// //         console.log("🎯 Seuil récupéré du backend :", fetchedThreshold);
// //         setThreshold(fetchedThreshold);
// //       } catch (err) {
// //         console.error("Erreur lors de la récupération du seuil :", err);
// //       }
// //     };
// //     loadThreshold();
// //   }, [courseId]);

// //   useEffect(() => {
// //     const loadProgress = async () => {
// //       try {
// //         if (!courseId || !userId) {
// //           console.warn("❗ Paramètres manquants pour récupération du progrès");
// //           return;
// //         }

// //         const fetchedProgress = await courseService.CalculePrgresseByType(
// //           "controle",
// //           courseId,
// //           userId,
// //           quizId
// //         );

// //         console.log("📊 Progression récupérée du backend :", fetchedProgress);
// //         setProgress(fetchedProgress);
// //       } catch (err) {
// //         console.error("❌ Erreur lors de la récupération du progrès :", err);
// //       }
// //     };

// //     loadProgress();
// //   }, [courseId, userId, quizId, refreshTrigger]);

  
// //   useEffect(() => {
// //     const fetchReview = async () => {
// //       console.log("🔍 [fetchReview] Conditions:", {
// //         submitted,
// //         quizId,
// //         shouldRun: submitted && quizId
// //       });

// //       if (!submitted || !quizId) {
// //         console.log("⏸️ [fetchReview] Arrêt - conditions non remplies");
// //         return;
// //       }

// //       try {
// //         const user = JSON.parse(localStorage.getItem("user"));
// //         console.log("🚀 [fetchReview] Appel API review pour userId:", user.id, "quizId:", quizId);

// //         const review = await courseService.getQuizReviewResults(user.id, quizId);

// //         // ✅ LOG COMPLET DE LA RÉPONSE
// //         console.log("=".repeat(60));
// //         console.log("🔁 REVIEW API - RÉPONSE COMPLÈTE");
// //         console.log("=".repeat(60));
// //         console.log(JSON.stringify(review, null, 2));
// //         console.log("=".repeat(60));

// //         // ✅ LOG PAR QUESTION
// //         review.forEach((q, index) => {
// //           console.log(`\n📝 Question ${index + 1}:`, {
// //             questionId: q.questionId,
// //             questionType: q.questionType,
// //             questionText: q.questionText,
// //             score: q.score
// //           });

// //           if (q.questionType === "DRAG_DROP_ZONES") {
// //             console.log("   🎯 Type: DRAG_DROP_ZONES détecté");
// //             console.log("   🎯 zoneAnswers:", q.zoneAnswers);

// //             if (!q.zoneAnswers) {
// //               console.error("   ❌ PROBLÈME: zoneAnswers est null ou undefined!");
// //             } else if (q.zoneAnswers.length === 0) {
// //               console.error("   ❌ PROBLÈME: zoneAnswers est un tableau vide!");
// //             } else {
// //               console.log(`   ✅ ${q.zoneAnswers.length} zone(s) trouvée(s)`);
// //               q.zoneAnswers.forEach((zone, i) => {
// //                 console.log(`   Zone ${i + 1}:`, {
// //                   zoneId: zone.zoneId,
// //                   zoneLabel: zone.zoneLabel,
// //                   correctAnswer: zone.correctAnswer,
// //                   userAnswer: zone.userAnswer,
// //                   correct: zone.correct
// //                 });
// //               });
// //             }
// //           } else {
// //             console.log("   📋 correctAnswers:", q.correctAnswers?.length || 0);
// //             console.log("   📋 userAnswers:", q.userAnswers?.length || 0);
// //           }
// //         });

// //         setmyscore_stored(review[0].score);
// //         setReviewResults(review);
// //         console.log("✅ Review chargée et state mis à jour");

// //       } catch (error) {
// //         console.error("=".repeat(60));
// //         console.error("❌ ERREUR lors du chargement de la review");
// //         console.error("=".repeat(60));
// //         console.error("Message:", error.message);
// //         console.error("Stack:", error.stack);
// //         console.error("Response:", error.response?.data);
// //         console.error("=".repeat(60));
// //       }
// //     };

// //     fetchReview();
// //   }, [submitted, quizId]);

// //   const buildAnswersPayload = () => {
// //     const answersArray = [];

// //     console.log("\n🔨 CONSTRUCTION DU PAYLOAD");
// //     console.log("=".repeat(60));

// //     questions.forEach((question, qIndex) => {
// //       const userAnswer = userAnswers[question.id];

// //       console.log(`\n📝 Question ${qIndex + 1} (ID: ${question.id}) - ${question.questionType}`);
// //       console.log(`   Réponse brute:`, userAnswer);

// //       // ✅ CAS 1 : Réponse simple (QCU, VRAI_FAUX)
// //       if (typeof userAnswer === "string") {
// //         const answer = question.options.find((opt) => opt.text === userAnswer);
// //         if (answer) {
// //           answersArray.push({
// //             questionId: question.id,
// //             answerId: answer.id,
// //           });
// //           console.log(`   ✅ Ajouté: answerId=${answer.id}`);
// //         } else {
// //           console.warn(`   ⚠️ Réponse "${userAnswer}" non trouvée dans les options`);
// //         }
// //       }

// //       // ✅ CAS 2 : DRAG_DROP (ordre important) - DOIT ÊTRE AVANT le cas Array générique
// //       else if (question.questionType === "DRAG_DROP" && Array.isArray(userAnswer)) {
// //         console.log(`   📋 Type DRAG_DROP détecté - Ordre: ${userAnswer.length} éléments`);

// //         userAnswer.forEach((answerText, orderIndex) => {
// //           const answer = question.options.find((opt) => opt.text === answerText);
// //           if (answer) {
// //             answersArray.push({
// //               questionId: question.id,
// //               answerId: answer.id,
// //             });
// //             console.log(`   ✅ Position ${orderIndex + 1}: answerId=${answer.id} ("${answerText}")`);
// //           } else {
// //             console.warn(`   ⚠️ Réponse "${answerText}" non trouvée`);
// //           }
// //         });
// //       }

// //       // ✅ CAS 3 : QCM (ordre pas important)
// //       else if (Array.isArray(userAnswer)) {
// //         console.log(`   📋 Réponses multiples QCM (${userAnswer.length}):`, userAnswer);
// //         userAnswer.forEach((answerText) => {
// //           const answer = question.options.find((opt) => opt.text === answerText);
// //           if (answer) {
// //             answersArray.push({
// //               questionId: question.id,
// //               answerId: answer.id,
// //             });
// //             console.log(`   ✅ Ajouté: answerId=${answer.id} pour "${answerText}"`);
// //           } else {
// //             console.warn(`   ⚠️ Réponse "${answerText}" non trouvée`);
// //           }
// //         });
// //       }

// //       // ✅ CAS 4 : DRAG_DROP_IMAGE
// //       else if (question.questionType === "DRAG_DROP_IMAGE" && typeof userAnswer === "object") {
// //         const zones = question.imageZones || [];
// //         const propositions = question.propositions || [];

// //         console.log(`   🖼️ ${zones.length} zones image, ${propositions.length} propositions`);

// //         Object.entries(userAnswer).forEach(([zoneId, content]) => {
// //           const proposition = propositions.find(p =>
// //             p.propositionContent === content ||
// //             p.content === content ||
// //             p.text === content
// //           );

// //           const zone = zones.find(z => z.id.toString() === zoneId);

// //           if (proposition && zone) {
// //             answersArray.push({
// //               questionId: question.id,
// //               imageZoneId: zone.id,
// //               propositionId: proposition.id,
// //             });
// //             console.log(`   ✅ Zone image ajoutée: imageZoneId=${zone.id}, propositionId=${proposition.id}`);
// //           } else {
// //             console.error(`   ❌ MAPPING ÉCHOUÉ pour zone image ${zoneId}`);
// //             console.error(`      Zone trouvée:`, zone ? `ID ${zone.id}` : 'NON');
// //             console.error(`      Proposition trouvée:`, proposition ? `ID ${proposition.id}` : 'NON');
// //           }
// //         });
// //       }

// //       // ✅ CAS 5 : DRAG_DROP_ZONES
// //       else if (question.questionType === "DRAG_DROP_ZONES" && typeof userAnswer === "object") {
// //         const zones = question.zones || [];
// //         const propositions = question.propositions || [];

// //         console.log(`   🎯 ${zones.length} zones, ${propositions.length} propositions`);
// //         console.log(`   🎯 Zones:`, zones.map(z => ({
// //           id: z.id,
// //           label: z.zoneLabel || z.label,
// //           correctAnswer: z.correctAnswer
// //         })));
// //         console.log(`   🧩 Propositions:`, propositions.map(p => ({
// //           id: p.id,
// //           content: p.propositionContent || p.content || p.text
// //         })));

// //         let addedCount = 0;
// //         Object.entries(userAnswer).forEach(([zoneId, content]) => {
// //           console.log(`   🔍 Traitement: Zone ${zoneId} = "${content}"`);

// //           const proposition = propositions.find(p =>
// //             p.propositionContent === content ||
// //             p.content === content ||
// //             p.text === content
// //           );

// //           const zone = zones.find(z => z.id.toString() === zoneId);

// //           if (proposition && zone) {
// //             answersArray.push({
// //               questionId: question.id,
// //               zoneId: zone.id,
// //               propositionId: proposition.id,
// //             });
// //             addedCount++;
// //             console.log(`   ✅ Ajouté: zoneId=${zone.id}, propositionId=${proposition.id}`);
// //           } else {
// //             console.error(`   ❌ MAPPING ÉCHOUÉ:`);
// //             console.error(`      Zone trouvée:`, zone ? `ID ${zone.id}` : 'NON');
// //             console.error(`      Proposition trouvée:`, proposition ? `ID ${proposition.id}` : 'NON');
// //             console.error(`      Contenu recherché: "${content}"`);
// //           }
// //         });

// //         console.log(`   📊 ${addedCount}/${Object.keys(userAnswer).length} zones mappées`);

// //         if (addedCount < zones.length) {
// //           console.warn(`   ⚠️ INCOMPLET: ${zones.length} zones attendues, seulement ${addedCount} mappées`);
// //         }
// //       }

// //       // ✅ CAS 6 : MATCHING
// //       else if (question.questionType === "MATCHING" && typeof userAnswer === "object") {
// //         const pairs = question.options || [];
// //         pairs.forEach((pair) => {
// //           const selected = userAnswer[pair.leftText];
// //           const answer = question.options.find(
// //             (opt) => opt.leftText === pair.leftText && opt.rightText === selected
// //           );
// //           if (answer && answer.id) {
// //             answersArray.push({
// //               questionId: question.id,
// //               answerId: answer.id,
// //             });
// //             console.log(`   ✅ Ajouté: answerId=${answer.id} (${pair.leftText} → ${selected})`);
// //           }
// //         });
// //       }
// //     });

// //     console.log("=".repeat(60));
// //     console.log(`📦 PAYLOAD FINAL: ${answersArray.length} réponses`);
// //     console.log(JSON.stringify(answersArray, null, 2));
// //     console.log("=".repeat(60));

// //     return answersArray;
// //   };

// //   const handleSubmit = async () => {
// //     setSubmitting(true);

// //     // ✅ Calcul du score
// //     const scoreNow = questions.reduce(
// //       (sum, q) => (isCorrect(q) ? sum + (q.score || 0) : sum),
// //       0
// //     );
// //     setScore(scoreNow);

// //     try {
// //       const user = JSON.parse(localStorage.getItem("user"));
// //       const payload = buildAnswersPayload();

// //       // ✅ LOG COMPLET DU PAYLOAD AVANT ENVOI
// //       console.log("=".repeat(60));
// //       console.log("📦 PAYLOAD COMPLET ENVOYÉ AU BACKEND");
// //       console.log("=".repeat(60));
// //       console.log(JSON.stringify({
// //         userId: user.id,
// //         quizId: quizId,
// //         scoreObtained: scoreNow,
// //         scoreTotal: totalPossibleScore,
// //         answers: payload
// //       }, null, 2));
// //       console.log("=".repeat(60));

// //       // ✅ LOG DÉTAILLÉ PAR TYPE DE QUESTION
// //       console.log("📊 DÉTAILS DES RÉPONSES PAR QUESTION:");
// //       questions.forEach((q, index) => {
// //         const userAnswer = userAnswers[q.id];
// //         const answersForThisQ = payload.filter(a => a.questionId === q.id);

// //         console.log(`\n📝 Question ${index + 1} (ID: ${q.id}) - Type: ${q.questionType}`);
// //         console.log(`   Texte: "${q.text}"`);
// //         console.log(`   Réponse utilisateur brute:`, userAnswer);
// //         console.log(`   Réponses dans le payload (${answersForThisQ.length}):`, answersForThisQ);

// //         if (q.questionType === "DRAG_DROP_ZONES") {
// //           console.log(`   🎯 Zones disponibles:`, q.zones?.map(z => ({
// //             id: z.id,
// //             label: z.zoneLabel || z.label
// //           })));
// //           console.log(`   🧩 Propositions disponibles:`, q.propositions?.map(p => ({
// //             id: p.id,
// //             content: p.propositionContent || p.content || p.text
// //           })));

// //           // Vérifier si toutes les zones ont une réponse
// //           const zonesCount = q.zones?.length || 0;
// //           const answersCount = answersForThisQ.length;
// //           if (zonesCount !== answersCount) {
// //             console.warn(`   ⚠️ ATTENTION: ${zonesCount} zones mais seulement ${answersCount} réponses!`);
// //           }
// //         }
// //       });
// //       console.log("=".repeat(60));

// //       // ✅ ENVOI AU BACKEND
// //       console.log("🚀 Envoi de la requête au backend...");
// //       const response = await courseService.submitQuizResult({
// //         userId: user.id,
// //         quizId: quizId,
// //         scoreObtained: scoreNow,
// //         scoreTotal: totalPossibleScore,
// //         answers: payload,
// //       });

// //       console.log("✅ Réponse du backend reçue:", response);
// //       console.log("✅ Résultat du quiz soumis avec succès.");

// //       setResultSaved(true);
// //       setSubmitted(true);

// //       setRefreshTrigger(prev => prev + 1);
// //       dispatch(recalculateNote(courseId, user.id));

// //     } catch (error) {
// //       console.error("=".repeat(60));
// //       console.error("❌ ERREUR LORS DE LA SOUMISSION");
// //       console.error("=".repeat(60));
// //       console.error("Message:", error.message);
// //       console.error("Stack:", error.stack);
// //       console.error("Response:", error.response?.data);
// //       console.error("=".repeat(60));
// //       alert("Une erreur est survenue lors de l'enregistrement du score: " +
// //         (error.response?.data?.message || error.message));
// //     } finally {
// //       setSubmitting(false);
// //     }
// //   };

// //   const DragDropPreview = ({ question }) => {
// //     // ✅ Vérifier d'abord si l'utilisateur a déjà répondu
// //     const existingAnswer = userAnswers[question.id];

// //     // ✅ Si oui, utiliser cet ordre. Sinon, utiliser l'ordre initial
// //     const getInitialItems = () => {
// //       if (existingAnswer && Array.isArray(existingAnswer)) {
// //         // Reconstruire les items depuis la réponse sauvegardée
// //         return existingAnswer.map((text, index) => ({
// //           id: `option-${index}`,
// //           content: text,
// //         }));
// //       }

// //       // Sinon, utiliser l'ordre initial des options
// //       return question.options.map((opt, index) => ({
// //         id: `option-${index}`,
// //         content: opt.text,
// //       }));
// //     };

// //     const [items, setItems] = useState(getInitialItems);

// //     const onDragEnd = (result) => {
// //       if (!result.destination) return;

// //       const reordered = Array.from(items);
// //       const [moved] = reordered.splice(result.source.index, 1);
// //       reordered.splice(result.destination.index, 0, moved);
// //       setItems(reordered);

// //       // ✅ Sauvegarder l'ordre dans userAnswers
// //       const orderedTexts = reordered.map(item => item.content);
// //       setUserAnswers({
// //         ...userAnswers,
// //         [question.id]: orderedTexts
// //       });

// //       console.log("✅ Ordre sauvegardé:", orderedTexts);
// //     };

// //     return (
// //       <div style={{ backgroundColor: "#f1f8e9", padding: "16px", borderRadius: "10px" }}>
// //         <DragDropContext onDragEnd={onDragEnd}>
// //           <Droppable droppableId="droppable-options">
// //             {(provided) => (
// //               <ul
// //                 {...provided.droppableProps}
// //                 ref={provided.innerRef}
// //                 style={{ listStyleType: "none", paddingLeft: 0 }}
// //               >
// //                 {items.map((item, index) => {
// //                   // ✅ Feedback visuel SEULEMENT après soumission
// //                   const userAnswer = userAnswers[question.id] || [];
// //                   const correctAnswer = question.correctAnswers || [];

// //                   let backgroundColor = "#e8f5e9"; // Couleur par défaut

// //                   if (submitted) {
// //                     // Vérifier si cet élément est à la bonne position
// //                     const isCorrectPosition = userAnswer[index] === correctAnswer[index];
// //                     backgroundColor = isCorrectPosition ? "#c8e6c9" : "#ffcdd2";
// //                   }

// //                   return (
// //                     <Draggable
// //                       key={item.id}
// //                       draggableId={item.id}
// //                       index={index}
// //                       isDragDisabled={submitted} // ✅ Désactiver le drag après soumission
// //                     >
// //                       {(provided, snapshot) => (
// //                         <li
// //                           ref={provided.innerRef}
// //                           {...provided.draggableProps}
// //                           {...provided.dragHandleProps}
// //                           style={{
// //                             padding: "12px 16px",
// //                             marginBottom: "8px",
// //                             backgroundColor: snapshot.isDragging ? "#c8e6c9" : backgroundColor,
// //                             border: snapshot.isDragging
// //                               ? "2px solid #66bb6a"
// //                               : submitted
// //                                 ? "1px solid #c8e6c9"
// //                                 : "1px solid #e0e0e0",
// //                             borderRadius: "8px",
// //                             cursor: submitted ? "default" : "grab",
// //                             display: "flex",
// //                             alignItems: "center",
// //                             justifyContent: "space-between",
// //                             transition: "all 0.2s ease",
// //                             ...provided.draggableProps.style,
// //                           }}
// //                         >
// //                           <span style={{ fontSize: "15px" }}>{item.content}</span>

// //                           {/* ✅ Icône de feedback APRÈS soumission */}
// //                           {submitted && userAnswer[index] && (
// //                             <span style={{ fontSize: "18px" }}>
// //                               {userAnswer[index] === correctAnswer[index] ? "✅" : "❌"}
// //                             </span>
// //                           )}
// //                         </li>
// //                       )}
// //                     </Draggable>
// //                   );
// //                 })}
// //                 {provided.placeholder}
// //               </ul>
// //             )}
// //           </Droppable>
// //         </DragDropContext>

// //         {/* ✅ Afficher l'ordre correct APRÈS soumission */}
// //         {/* {submitted && (
// //           <div style={{
// //             marginTop: "16px",
// //             padding: "12px",
// //             background: "#fff3cd",
// //             borderRadius: "8px",
// //             border: "1px solid #ffc107"
// //           }}>
// //             <strong style={{ color: "#856404" }}>✅ Ordre correct :</strong>
// //             <ol style={{ marginTop: "8px", marginBottom: 0, paddingLeft: "20px" }}>
// //               {question.correctAnswers?.map((answer, idx) => (
// //                 <li key={idx} style={{ color: "#856404", marginBottom: "4px" }}>
// //                   {answer}
// //                 </li>
// //               ))}
// //             </ol>
// //           </div> */}
// //         {/* )} */}
// //       </div>
// //     );
// //   };


// //   const renderQuestion = (question) => {
// //     const userAnswer = userAnswers[question.id];

// //     if (question.questionType === "QCU" || question.questionType === "VRAI_FAUX") {
// //   return (
// //     <div style={{
// //       display: question.imageUrl ? 'grid' : 'block',
// //       gridTemplateColumns: question.imageUrl ? '1fr 1fr' : '1fr',
// //       gap: '20px',
// //       alignItems: 'start'
// //     }}>
// //       <Radio.Group
// //         value={userAnswer}
// //         onChange={(e) => setUserAnswers({ ...userAnswers, [question.id]: e.target.value })}
// //         disabled={submitted}
// //         style={{ display: "flex", flexDirection: "column", gap: "12px" }}
// //       >
// //         {(question.options || []).map((option, i) => {
// //           const isSelected = userAnswer === option.text;
// //           const isCorrect = question.correctAnswers?.includes(option.text);
// //           const showFeedback = submitted;

// //           let backgroundColor = "transparent";
// //           if (showFeedback) {
// //             if (isCorrect) backgroundColor = "#e8f5e9";
// //             else if (isSelected && !isCorrect) backgroundColor = "#ffebee";
// //           }

// //           return (
// //             <Radio
// //               key={i}
// //               value={option.text}
// //               style={{
// //                 backgroundColor,
// //                 borderRadius: "8px",
// //                 padding: "12px 16px",
// //                 display: "flex",
// //                 alignItems: "center",
// //                 border: "1px solid #e0e0e0",
// //                 transition: "all 0.2s ease"
// //               }}
// //             >
// //               <span style={{ fontSize: "15px" }}>{option.text}</span>
// //               {showFeedback && isCorrect && (
// //                 <span style={{ marginLeft: "12px", color: "green", fontSize: "18px" }}>✅</span>
// //               )}
// //               {showFeedback && isSelected && !isCorrect && (
// //                 <span style={{ marginLeft: "12px", color: "red", fontSize: "18px" }}>❌</span>
// //               )}
// //             </Radio>
// //           );
// //         })}
// //       </Radio.Group>

// //       {/* 🆕 IMAGE DE LA QUESTION */}
// //       {question.imageUrl && (
// //         <div style={{
// //           borderRadius: '12px',
// //           overflow: 'hidden',
// //           border: '2px solid #e9ecef',
// //           background: '#fafafa',
// //           position: 'relative',
// //           boxShadow: '0 4px 15px rgba(0, 0, 0, 0.08)'
// //         }}>
// //           <div style={{
// //             position: 'absolute',
// //             top: '10px',
// //             left: '10px',
// //             background: 'rgba(0, 0, 0, 0.6)',
// //             color: 'white',
// //             padding: '4px 10px',
// //             borderRadius: '6px',
// //             fontSize: '11px',
// //             fontWeight: '500',
// //             zIndex: 1,
// //             backdropFilter: 'blur(4px)'
// //           }}>
// //             🖼️ Illustration
// //           </div>
// //           <img
// //             src={question.imageUrl}
// //             alt="Illustration de la question"
// //             style={{
// //               width: '100%',
// //               display: 'block',
// //               objectFit: 'contain',
// //               maxHeight: '400px'
// //             }}
// //           />
// //         </div>
// //       )}
// //     </div>
// //   );
// // }

// //    if (question.questionType === "QCM") {
// //   const selectedAnswers = userAnswer || [];

// //   return (
// //     <div style={{
// //       display: question.imageUrl ? 'grid' : 'block',
// //       gridTemplateColumns: question.imageUrl ? '1fr 1fr' : '1fr',
// //       gap: '20px',
// //       alignItems: 'start'
// //     }}>
// //       <Checkbox.Group
// //         value={selectedAnswers}
// //         onChange={(values) => setUserAnswers({ ...userAnswers, [question.id]: values })}
// //         disabled={submitted}
// //         style={{ display: "flex", flexDirection: "column", gap: "12px" }}
// //       >
// //         {(question.options || []).map((option, i) => {
// //           const isSelected = selectedAnswers.includes(option.text);
// //           const isCorrect = question.correctAnswers?.includes(option.text);
// //           const showFeedback = submitted;

// //           let backgroundColor = "transparent";
// //           if (showFeedback) {
// //             if (isCorrect) backgroundColor = "#e8f5e9";
// //             else if (isSelected && !isCorrect) backgroundColor = "#ffebee";
// //           }

// //           return (
// //             <Checkbox
// //               key={i}
// //               value={option.text}
// //               style={{
// //                 backgroundColor,
// //                 borderRadius: "8px",
// //                 padding: "12px 16px",
// //                 display: "flex",
// //                 alignItems: "center",
// //                 border: "1px solid #e0e0e0",
// //                 transition: "all 0.2s ease"
// //               }}
// //             >
// //               <span style={{ fontSize: "15px" }}>{option.text}</span>
// //               {showFeedback && isCorrect && (
// //                 <span style={{ marginLeft: "12px", color: "green", fontSize: "18px" }}>✅</span>
// //               )}
// //               {showFeedback && isSelected && !isCorrect && (
// //                 <span style={{ marginLeft: "12px", color: "red", fontSize: "18px" }}>❌</span>
// //               )}
// //             </Checkbox>
// //           );
// //         })}
// //       </Checkbox.Group>

// //       {/* 🆕 IMAGE DE LA QUESTION */}
// //       {question.imageUrl && (
// //         <div style={{
// //           borderRadius: '12px',
// //           overflow: 'hidden',
// //           border: '2px solid #e9ecef',
// //           background: '#fafafa',
// //           position: 'relative',
// //           boxShadow: '0 4px 15px rgba(0, 0, 0, 0.08)'
// //         }}>
// //           <div style={{
// //             position: 'absolute',
// //             top: '10px',
// //             left: '10px',
// //             background: 'rgba(0, 0, 0, 0.6)',
// //             color: 'white',
// //             padding: '4px 10px',
// //             borderRadius: '6px',
// //             fontSize: '11px',
// //             fontWeight: '500',
// //             zIndex: 1,
// //             backdropFilter: 'blur(4px)'
// //           }}>
// //             🖼️ Illustration
// //           </div>
// //           <img
// //             src={question.imageUrl}
// //             alt="Illustration de la question"
// //             style={{
// //               width: '100%',
// //               display: 'block',
// //               objectFit: 'contain',
// //               maxHeight: '400px'
// //             }}
// //           />
// //         </div>
// //       )}
// //     </div>
// //   );
// // }

// //     if (question.questionType === "DRAG_DROP") {
// //       return <DragDropPreview question={question} />;
// //     }
// //     if (question.questionType === "DRAG_DROP_IMAGE") {
// //       const zones = (question.imageZones || []).map(zone => ({
// //         id: zone.id,
// //         label: zone.zoneLabel,
// //         correctAnswer: zone.correctAnswer,
// //         x: zone.posX,  // ✅ Corrigé
// //         y: zone.posY,
// //         width: zone.width,
// //         height: zone.height
// //       }));

// //       const propositions = (question.propositions || []).map(prop => ({
// //         id: prop.id,
// //         content: prop.propositionContent || prop.content || prop.text
// //       }));

// //       const handleAnswerChange = (answer) => {
// //         console.log("🖼️ DRAG_DROP_IMAGE - handleAnswerChange appelé avec:", answer);
// //         console.log("   Type de answer:", typeof answer);
// //         console.log("   answer.zoneId:", answer.zoneId);
// //         console.log("   answer.content:", answer.content);
// //         console.log("   Object.keys(answer):", Object.keys(answer));

// //         // ✅ CORRECTION: Vérifier si c'est un objet {zoneId: content} plutôt que {zoneId: X, content: Y}
// //         const isZoneMapping = typeof answer === 'object' && !answer.zoneId && !answer.content;

// //         if (isZoneMapping) {
// //           console.log("   📦 Format zone mapping détecté - Fusion avec état existant");

// //           // ✅ FUSIONNER avec l'état existant au lieu d'écraser
// //           const newAnswers = {
// //             ...(userAnswer || {}),
// //             ...answer  // Fusionner les nouvelles zones avec les existantes
// //           };

// //           setUserAnswers({
// //             ...userAnswers,
// //             [question.id]: newAnswers
// //           });
// //           console.log("   ✅ State fusionné:", newAnswers);
// //           return;
// //         }

// //         // Format individuel {zoneId: 7, content: "Tanger"}
// //         console.log("   📋 Format individuel détecté");
// //         const newAnswers = {
// //           ...(userAnswer || {}),
// //           [answer.zoneId]: answer.content
// //         };

// //         setUserAnswers({
// //           ...userAnswers,
// //           [question.id]: newAnswers
// //         });

// //         console.log("   ✅ State après setUserAnswers:", newAnswers);
// //       };

// //       return (
// //         <DragDropImage
// //           imageUrl={question.imageUrl}
// //           dropZones={zones}
// //           propositions={propositions}
// //           onAnswerChange={handleAnswerChange}
// //           showCorrectAnswers={submitted}
// //           initialFilledZones={userAnswer || {}}
// //         />
// //       );
// //     }
// //     if (question.questionType === "MATCHING") {
// //       return (
// //         <MatchingQuestionViewer
// //           key={submitted + JSON.stringify(userAnswers[question.id] || {})}
// //           pairs={question.options || []}
// //           questionId={question.id}
// //           userAnswers={userAnswers}
// //           setUserAnswers={setUserAnswers}
// //           disabled={submitted}
// //         />
// //       );
// //     }

// //     if (question.questionType === "DRAG_DROP_ZONES") {
// //       const zones = (question.zones || []).map(zone => ({
// //         id: zone.id.toString(),
// //         label: zone.zoneLabel || zone.label,
// //         correctAnswer: zone.correctAnswer
// //       }));

// //       const propositions = (question.propositions || []).map(prop => ({
// //         id: prop.id.toString(),
// //         content: prop.propositionContent || prop.content || prop.text
// //       }));

// //       const handleAnswerChange = (answer) => {
// //         console.log("🖼️ DRAG_DROP_IMAGE - handleAnswerChange appelé avec:", answer);

// //         // ✅ FIX: Si answer est déjà un objet complet {zoneId: content, ...}
// //         if (typeof answer === 'object' && !answer.zoneId) {
// //           console.log("   📦 Format complet détecté - Mise à jour directe");
// //           setUserAnswers({
// //             ...userAnswers,
// //             [question.id]: answer
// //           });
// //           console.log("   ✅ State mis à jour avec:", answer);
// //           return;
// //         }

// //         // Format individuel {zoneId: X, content: Y}
// //         console.log("   answer.zoneId:", answer.zoneId);
// //         console.log("   answer.content:", answer.content);
// //         console.log("   userAnswer actuel:", userAnswer);

// //         const newAnswers = {
// //           ...(userAnswer || {}),
// //           [answer.zoneId]: answer.content
// //         };

// //         console.log("   newAnswers calculé:", newAnswers);

// //         setUserAnswers({
// //           ...userAnswers,
// //           [question.id]: newAnswers
// //         });

// //         console.log("   ✅ State après setUserAnswers:", {
// //           ...userAnswers,
// //           [question.id]: newAnswers
// //         });
// //       };
// //       return (
// //         <DragDropZones
// //           zones={zones}
// //           propositions={propositions}
// //           onAnswerChange={handleAnswerChange}
// //           showCorrectAnswers={false}  // ✅ Mettez true temporairement pour tester
// //           initialFilledZones={userAnswer || {}}
// //         />
// //       );
// //     }

// //     return <p style={{ color: "red" }}>❗ Type non supporté : {question.questionType}</p>;
// //   };

// //   // ✅ FONCTION POUR RENDRE L'INTRODUCTION PROFESSIONNELLE
// //   const renderIntroduction = () => (
// //     <div
// //       style={{
// //         minHeight: '100vh',
// //         background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)',
// //         display: 'flex',
// //         alignItems: 'center',
// //         justifyContent: 'center',
// //         padding: '20px',
// //         fontFamily: "'Segoe UI', 'Roboto', sans-serif"
// //       }}
// //     >
// //       <div
// //         style={{
// //           background: '#ffffff',
// //           borderRadius: '16px',
// //           padding: '0',
// //           maxWidth: '1200px',
// //           width: '100%',
// //           boxShadow: '0 20px 60px rgba(0, 0, 0, 0.1)',
// //           overflow: 'hidden'
// //         }}
// //       >
// //         {/* HEADER PROFESSIONNEL */}
// //         <div style={{
// //           background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
// //           color: 'white',
// //           padding: '30px 40px',
// //           display: 'flex',
// //           justifyContent: 'space-between',
// //           alignItems: 'center'
// //         }}>
// //           <div>
// //             <div style={{
// //               fontSize: '12px',
// //               textTransform: 'uppercase',
// //               letterSpacing: '1px',
// //               opacity: '0.9',
// //               marginBottom: '8px'
// //             }}>
// //               {quiz?.linkType === 'evaluation' ? 'ÉVALUATION' : 'CONTRÔLE DE CONNAISSANCES'}
// //             </div>
// //             <h1 style={{
// //               fontSize: '28px',
// //               fontWeight: '700',
// //               margin: '0',
// //               lineHeight: '1.2'
// //             }}>
// //               {quiz?.title || 'Test de connaissances'}
// //             </h1>
// //           </div>
// //           <div style={{
// //             textAlign: 'right',
// //             fontSize: '14px',
// //             opacity: '0.9'
// //           }}>
// //             <div>{quiz?.course?.title || 'Cours en ligne'}</div>
// //           </div>
// //         </div>

// //         {/* CONTENU PRINCIPAL */}
// //         <div style={{
// //           display: 'grid',
// //           gridTemplateColumns: '2fr 1fr',
// //           gap: '0'
// //         }}>
// //           {/* SECTION GAUCHE : INTRODUCTION */}
// //           <div style={{ padding: '40px' }}>
// //             <h2 style={{
// //               fontSize: '20px',
// //               fontWeight: '600',
// //               color: '#2c3e50',
// //               marginBottom: '20px',
// //               borderBottom: '2px solid #e9ecef',
// //               paddingBottom: '10px'
// //             }}>
// //               📋 Présentation du contrôle
// //             </h2>

// //             {quiz?.introductionText && quiz.introductionText.trim() !== '' ? (
// //               <div
// //                 style={{
// //                   fontSize: '15px',
// //                   lineHeight: '1.7',
// //                   color: '#495057',
// //                   background: '#f8f9fa',
// //                   padding: '25px',
// //                   borderRadius: '12px',
// //                   border: '1px solid #e9ecef'
// //                 }}
// //                 dangerouslySetInnerHTML={{ __html: quiz.introductionText }}
// //               />
// //             ) : (
// //               <div style={{
// //                 fontSize: '15px',
// //                 lineHeight: '1.7',
// //                 color: '#6c757d',
// //                 fontStyle: 'italic'
// //               }}>
// //                 Ce contrôle évalue vos connaissances sur les sujets abordés dans le cours.
// //                 Lisez attentivement chaque question avant de répondre.
// //               </div>
// //             )}

// //             {/* INSTRUCTIONS */}
// //             <div style={{ marginTop: '30px' }}>
// //               <h3 style={{
// //                 fontSize: '16px',
// //                 fontWeight: '600',
// //                 color: '#2c3e50',
// //                 marginBottom: '15px'
// //               }}>
// //                 🎯 Instructions
// //               </h3>
// //               <div style={{
// //                 display: 'grid',
// //                 gridTemplateColumns: '1fr 1fr',
// //                 gap: '15px',
// //                 fontSize: '14px',
// //                 color: '#495057'
// //               }}>
// //                 <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
// //                   <span style={{ color: '#28a745', fontSize: '16px' }}>📖</span>
// //                   <span>Lisez chaque question attentivement</span>
// //                 </div>
// //                 <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
// //                   <span style={{ color: '#17a2b8', fontSize: '16px' }}>🤔</span>
// //                   <span>Réfléchissez avant de répondre</span>
// //                 </div>
// //                 <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
// //                   <span style={{ color: '#ffc107', fontSize: '16px' }}>⏰</span>
// //                   <span>Gérez votre temps efficacement</span>
// //                 </div>
// //                 <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
// //                   <span style={{ color: '#dc3545', fontSize: '16px' }}>✅</span>
// //                   <span>Vérifiez vos réponses</span>
// //                 </div>
// //               </div>
// //             </div>
// //           </div>

// //           {/* SECTION DROITE : STATISTIQUES */}
// //           <div style={{
// //             background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
// //             padding: '40px 30px',
// //             borderLeft: '1px solid #e9ecef'
// //           }}>
// //             {/* STATISTIQUES DU QUIZ */}
// //             <div style={{
// //               background: 'white',
// //               borderRadius: '12px',
// //               padding: '25px',
// //               marginBottom: '25px',
// //               boxShadow: '0 4px 15px rgba(0, 0, 0, 0.05)'
// //             }}>
// //               <h3 style={{
// //                 fontSize: '16px',
// //                 fontWeight: '600',
// //                 color: '#2c3e50',
// //                 marginBottom: '20px',
// //                 textAlign: 'center'
// //               }}>
// //                 📊 Informations
// //               </h3>

// //               <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
// //                 <div style={{
// //                   display: 'flex',
// //                   justifyContent: 'space-between',
// //                   alignItems: 'center',
// //                   padding: '10px 15px',
// //                   background: '#f8f9fa',
// //                   borderRadius: '8px'
// //                 }}>
// //                   <span style={{ color: '#6c757d', fontSize: '14px' }}>
// //                     <BookOutlined style={{ marginRight: '8px', color: '#1976d2' }} />
// //                     Questions
// //                   </span>
// //                   <strong style={{ color: '#1976d2', fontSize: '16px' }}>
// //                     {questions.length}
// //                   </strong>
// //                 </div>

// //                 <div style={{
// //                   display: 'flex',
// //                   justifyContent: 'space-between',
// //                   alignItems: 'center',
// //                   padding: '10px 15px',
// //                   background: '#f8f9fa',
// //                   borderRadius: '8px'
// //                 }}>
// //                   <span style={{ color: '#6c757d', fontSize: '14px' }}>
// //                     <TrophyOutlined style={{ marginRight: '8px', color: '#388e3c' }} />
// //                     Points
// //                   </span>
// //                   <strong style={{ color: '#388e3c', fontSize: '16px' }}>
// //                     {totalPossibleScore}
// //                   </strong>
// //                 </div>

// //                 <div style={{
// //                   display: 'flex',
// //                   justifyContent: 'space-between',
// //                   alignItems: 'center',
// //                   padding: '10px 15px',
// //                   background: '#f8f9fa',
// //                   borderRadius: '8px'
// //                 }}>
// //                   <span style={{ color: '#6c757d', fontSize: '14px' }}>
// //                     <ClockCircleOutlined style={{ marginRight: '8px', color: '#f57c00' }} />
// //                     Durée estimée
// //                   </span>
// //                   <strong style={{ color: '#f57c00', fontSize: '16px' }}>
// //                     ~{Math.ceil(questions.length * 1.5)} min
// //                   </strong>
// //                 </div>
// //               </div>
// //             </div>

// //             {/* TYPE DE TENTATIVE */}
// //             <div style={{
// //               background: quiz?.attemptOnce ? '#fff3cd' : '#d1ecf1',
// //               border: `1px solid ${quiz?.attemptOnce ? '#ffeaa7' : '#bee5eb'}`,
// //               borderRadius: '12px',
// //               padding: '20px',
// //               textAlign: 'center'
// //             }}>
// //               <div style={{
// //                 fontSize: '14px',
// //                 fontWeight: '600',
// //                 color: quiz?.attemptOnce ? '#856404' : '#0c5460',
// //                 marginBottom: '8px'
// //               }}>
// //                 {quiz?.attemptOnce ? '⚠️ TENTATIVE UNIQUE' : '✅ TENTATIVES MULTIPLES'}
// //               </div>
// //               <div style={{
// //                 fontSize: '13px',
// //                 color: quiz?.attemptOnce ? '#856404' : '#0c5460',
// //                 lineHeight: '1.4'
// //               }}>
// //                 {quiz?.attemptOnce
// //                   ? 'Vous n\'aurez qu\'une seule chance. Assurez-vous d\'être prêt !'
// //                   : 'Vous pouvez refaire ce quiz autant de fois que nécessaire.'
// //                 }
// //               </div>
// //             </div>

// //             {/* BOUTON DE DÉMARRAGE */}
// //             <Button
// //               type="primary"
// //               size="large"
// //               onClick={handleStartQuiz}
// //               style={{
// //                 width: '100%',
// //                 height: '50px',
// //                 marginTop: '25px',
// //                 fontSize: '16px',
// //                 fontWeight: '600',
// //                 background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
// //                 border: 'none',
// //                 borderRadius: '12px',
// //                 boxShadow: '0 4px 15px rgba(102, 126, 234, 0.4)'
// //               }}
// //             >
// //               🚀 Commencer le contrôle
// //             </Button>
// //           </div>
// //         </div>
// //       </div>
// //     </div>
// //   );

// //   const renderQuizSummaryModal = () => (
// //     <Modal
// //       title={
// //         <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
// //           <FileTextOutlined style={{ color: "#1890ff", fontSize: 20 }} />
// //           <span style={{ fontSize: "18px", fontWeight: 600 }}>Résumé de vos réponses</span>
// //         </div>
// //       }
// //       open={showSummaryModal}
// //       onCancel={() => setShowSummaryModal(false)}
// //       onOk={async () => {
// //         setShowSummaryModal(false);
// //         await handleSubmit();
// //       }}
// //       okText="✅ Confirmer l'envoi"
// //       cancelText="✖️ Modifier mes réponses"
// //       okButtonProps={{ type: "primary" }}
// //       width={650}
// //     >
// //       <Divider style={{ margin: "10px 0 20px 0" }} />
// //       <List
// //         dataSource={questions}
// //         renderItem={(question, index) => {
// //           const userAnswer = userAnswers[question.id];
// //           const userText = Array.isArray(userAnswer)
// //             ? userAnswer.join(", ")
// //             : typeof userAnswer === "object"
// //               ? "[Réponse structurée]"
// //               : userAnswer || "Non répondu";

// //           return (
// //             <List.Item
// //               style={{
// //                 backgroundColor: "#f9f9f9",
// //                 borderLeft: "6px solid #1890ff",
// //                 padding: "14px 18px",
// //                 borderRadius: "10px",
// //                 marginBottom: 10,
// //                 transition: "transform 0.2s ease",
// //               }}
// //               onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.01)")}
// //               onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
// //             >
// //               <List.Item.Meta
// //                 title={
// //                   <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
// //                     <Badge
// //                       count={`Q${index + 1}`}
// //                       style={{
// //                         backgroundColor: "#1890ff",
// //                         fontWeight: 600,
// //                       }}
// //                     />
// //                     <span style={{ fontWeight: 500 }}>{question.text}</span>
// //                   </div>
// //                 }
// //                 description={
// //                   <div style={{ marginTop: 4 }}>
// //                     <div style={{ marginTop: 4 }}>
// //                       <strong>Votre réponse :</strong> {userText}
// //                     </div>
// //                   </div>
// //                 }
// //               />
// //             </List.Item>
// //           );
// //         }}
// //       />
// //       <Divider />
// //       <div style={{ textAlign: "center", color: "#888", fontSize: 13 }}>
// //         <InfoCircleTwoTone twoToneColor="#1890ff" /> Vérifiez vos réponses avant l'envoi définitif.
// //       </div>
// //     </Modal>
// //   );

// //   // ✅ CONDITIONS DE RETOUR
// //   if (loading) {
// //     return (
// //       <div style={{
// //         minHeight: '100vh',
// //         display: 'flex',
// //         alignItems: 'center',
// //         justifyContent: 'center',
// //         background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)'
// //       }}>
// //         <div style={{
// //           background: 'white',
// //           padding: '40px',
// //           borderRadius: '20px',
// //           textAlign: 'center',
// //           boxShadow: '0 20px 60px rgba(0, 0, 0, 0.15)'
// //         }}>
// //           <Spin size="large" />
// //           <p style={{ marginTop: '20px', fontSize: '16px', color: '#666' }}>
// //             Chargement du quiz.......
// //           </p>
// //         </div>
// //       </div>
// //     );
// //   }

// //   if (error) {
// //     return (
// //       <div style={{
// //         minHeight: '100vh',
// //         display: 'flex',
// //         alignItems: 'center',
// //         justifyContent: 'center',
// //         background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)',
// //         padding: '20px'
// //       }}>
// //         <Alert
// //           message="Erreur"
// //           description={error}
// //           type="error"
// //           showIcon
// //           style={{ maxWidth: '500px' }}
// //         />
// //       </div>
// //     );
// //   }

// //   // ✅ AFFICHER L'INTRODUCTION
// //   if (showIntroduction && quiz) {
// //     console.log("🎨 Affichage de l'introduction");
// //     return renderIntroduction();
// //   }

// //   if (!questions[currentStep]) {
// //     return (
// //       <div style={{ textAlign: 'center', padding: '50px' }}>
// //         <Alert message="Question non trouvée." type="error" />
// //       </div>
// //     );
// //   }

// //   // ✅ RENDU PRINCIPAL DES QUESTIONS AVEC DESIGN AMÉLIORÉ
// //   return (
// //     <div style={{
// //       minHeight: '100vh',
// //       background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
// //       padding: '20px'
// //     }}>
// //       <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
// //         {/* HEADER DU QUIZ AMÉLIORÉ */}
// //         <div style={{
// //           background: 'white',
// //           borderRadius: '16px',
// //           padding: '25px 30px',
// //           marginBottom: '25px',
// //           boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
// //           border: '1px solid #e9ecef'
// //         }}>
// //           <div style={{
// //             display: 'flex',
// //             justifyContent: 'space-between',
// //             alignItems: 'center',
// //             marginBottom: '20px'
// //           }}>
// //             <div>
// //               <div style={{
// //                 fontSize: '12px',
// //                 textTransform: 'uppercase',
// //                 letterSpacing: '1px',
// //                 color: '#6c757d',
// //                 marginBottom: '5px'
// //               }}>
// //                 {quiz?.linkType === 'evaluation' ? 'ÉVALUATION' : 'CONTRÔLE DE CONNAISSANCES'}
// //               </div>
// //               <h2 style={{
// //                 margin: 0,
// //                 fontSize: '24px',
// //                 fontWeight: '700',
// //                 color: '#2c3e50'
// //               }}>
// //                 {quiz?.title || 'Quiz'}
// //               </h2>
// //             </div>
// //             {submitted && (
// //               <div style={{
// //                 background: 'linear-gradient(135deg, #28a745, #20c997)',
// //                 color: 'white',
// //                 padding: '12px 20px',
// //                 borderRadius: '12px',
// //                 fontSize: '16px',
// //                 fontWeight: '600',
// //                 display: 'flex',
// //                 alignItems: 'center',
// //                 gap: '8px'
// //               }}>
// //                 <TrophyOutlined />
// //                 Score : {calculateScore()} / {totalPossibleScore}
// //               </div>
// //             )}
// //           </div>

// //           {/* PROGRESS STEPS PROFESSIONNELS */}
// //           <Steps
// //             current={currentStep}
// //             onChange={(step) => submitted && setCurrentStep(step)}
// //             size="small"
// //             style={{ marginBottom: 0 }}
// //           >
// //             {questions.map((q, index) => {
// //               const correct = isCorrect(q);
// //               const isActive = currentStep === index;

// //               const icon = submitted ? (
// //                 correct ? (
// //                   <CheckCircleTwoTone twoToneColor="#52c41a" />
// //                 ) : (
// //                   <CloseCircleTwoTone twoToneColor="#ff4d4f" />
// //                 )
// //               ) : undefined;

// //               return (
// //                 <Step
// //                   key={q.id}
// //                   icon={icon}
// //                   title={
// //                     <span style={{
// //                       fontWeight: isActive ? "bold" : "normal",
// //                       color: submitted
// //                         ? correct
// //                           ? "#52c41a"
// //                           : "#ff4d4f"
// //                         : isActive
// //                           ? "#1890ff"
// //                           : undefined
// //                     }}>
// //                       Q{index + 1}
// //                     </span>
// //                   }
// //                 />
// //               );
// //             })}
// //           </Steps>
// //         </div>

// //         {/* CARTE DE QUESTION PROFESSIONNELLE */}
// //         <Card
// //           title={
// //             <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
// //               <span style={{ fontSize: '18px', fontWeight: '600', color: '#2c3e50' }}>
// //                 Question {currentStep + 1} : {questions[currentStep].text || "Sans titre"}
// //               </span>
// //               <Tag color="blue" style={{ fontSize: '14px', padding: '4px 12px' }}>
// //                 {questions[currentStep].score || 0} pts
// //               </Tag>
// //             </div>
// //           }
// //           style={{
// //             marginBottom: "25px",
// //             borderRadius: '16px',
// //             boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
// //             border: '1px solid #e9ecef'
// //           }}
// //           bodyStyle={{ padding: '30px' }}
// //         >
// //           {renderQuestion(questions[currentStep])}

// //           {submitted && (
// //             <div style={{
// //               marginTop: "25px",
// //               padding: "20px",
// //               backgroundColor: isCorrect(questions[currentStep]) ? "#e8f5e9" : "#ffebee",
// //               borderRadius: "12px",
// //               border: `2px solid ${isCorrect(questions[currentStep]) ? "#4caf50" : "#f44336"}`
// //             }}>
// //               <div style={{
// //                 display: 'flex',
// //                 alignItems: 'center',
// //                 gap: '12px',
// //                 marginBottom: '12px'
// //               }}>
// //                 <span style={{
// //                   fontSize: '22px',
// //                   color: isCorrect(questions[currentStep]) ? "#2e7d32" : "#c62828"
// //                 }}>
// //                   {isCorrect(questions[currentStep]) ? "✔️" : "❌"}
// //                 </span>
// //                 <strong style={{
// //                   color: isCorrect(questions[currentStep]) ? "#2e7d32" : "#c62828",
// //                   fontSize: '16px'
// //                 }}>
// //                   {isCorrect(questions[currentStep]) ? "Excellente réponse !" : "Réponse incorrecte"}
// //                 </strong>
// //               </div>

// //               {questions[currentStep].explanation &&
// //                 isValidHtml(questions[currentStep].explanation) && (
// //                   <div style={{
// //                     marginTop: "15px",
// //                     padding: '15px',
// //                     background: 'rgba(255, 255, 255, 0.9)',
// //                     borderRadius: '8px',
// //                     border: '1px solid rgba(0, 0, 0, 0.1)'
// //                   }}>
// //                     <strong style={{ color: '#5d4037', fontSize: '15px' }}>💡 Explication :</strong>
// //                     <div style={{ marginTop: '8px' }}>
// //                       <span
// //                         dangerouslySetInnerHTML={{
// //                           __html: questions[currentStep].explanation,
// //                         }}
// //                       />
// //                     </div>
// //                   </div>
// //                 )}
// //             </div>
// //           )}
// //         </Card>

// //         {/* NAVIGATION PROFESSIONNELLE */}
// //         <div style={{
// //           background: 'white',
// //           borderRadius: '16px',
// //           padding: '25px 30px',
// //           display: 'flex',
// //           justifyContent: 'space-between',
// //           alignItems: 'center',
// //           boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
// //           border: '1px solid #e9ecef'
// //         }}>
// //           <Button
// //             onClick={() => setCurrentStep((prev) => prev - 1)}
// //             disabled={currentStep === 0}
// //             size="large"
// //             style={{
// //               minWidth: '140px',
// //               borderRadius: '8px',
// //               fontWeight: '500'
// //             }}
// //           >
// //             ← Précédent
// //           </Button>

// //           <div style={{
// //             display: 'flex',
// //             alignItems: 'center',
// //             gap: '15px',
// //             background: '#f8f9fa',
// //             padding: '12px 20px',
// //             borderRadius: '8px'
// //           }}>
// //             <span style={{ color: '#6c757d', fontSize: '14px', fontWeight: '500' }}>
// //               Question {currentStep + 1} sur {questions.length}
// //             </span>
// //             <Progress
// //               percent={((currentStep + 1) / questions.length) * 100}
// //               showInfo={false}
// //               style={{ width: '120px' }}
// //               strokeColor="#667eea"
// //             />
// //           </div>

// //           {currentStep < questions.length - 1 ? (
// //             <Button
// //               onClick={() => setCurrentStep((prev) => prev + 1)}
// //               type="primary"
// //               size="large"
// //               style={{
// //                 minWidth: '140px',
// //                 borderRadius: '8px',
// //                 fontWeight: '500',
// //                 background: '#667eea'
// //               }}
// //             >
// //               Suivant →
// //             </Button>
// //           ) : (
// //             !submitted && (
// //               <>
// //                 <Button
// //                   type="primary"
// //                   onClick={() => setShowSummaryModal(true)}
// //                   loading={submitting}
// //                   disabled={submitting}
// //                   size="large"
// //                   style={{
// //                     minWidth: '180px',
// //                     borderRadius: '8px',
// //                     fontWeight: '600',
// //                     background: submitting ? "#6c757d" : 'linear-gradient(135deg, #28a745, #20c997)',
// //                     border: 'none'
// //                   }}
// //                 >
// //                   {submitting ? "Envoi en cours..." : "🚀 Soumettre le quiz"}
// //                 </Button>

// //               </>
// //             )
// //           )}
// //         </div>

// //         {/* RÉSULTATS PROFESSIONNELS */}
// //         {submitted && (
// //           <div style={{ marginTop: '30px' }}>
// //             <div style={{
// //               background: 'white',
// //               borderRadius: '16px',
// //               padding: '30px',
// //               textAlign: 'center',
// //               boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
// //               marginBottom: '25px',
// //               border: '1px solid #e9ecef'
// //             }}>
// //               <div style={{ marginBottom: '25px' }}>
// //                 <Button
// //                   type="default"
// //                   disabled={attemptOnce}
// //                   onClick={() => {
// //                     if (!attemptOnce) {
// //                       setSubmitted(false);
// //                       setUserAnswers({});
// //                       setCurrentStep(0);
// //                     }
// //                   }}
// //                   style={{
// //                     marginRight: '15px',
// //                     borderRadius: '8px',
// //                     fontWeight: '500'
// //                   }}
// //                   size="large"
// //                 >
// //                   🔄 Recommencer
// //                 </Button>

// //                 <span style={{
// //                   fontWeight: "600",
// //                   color: attemptOnce ? "#dc3545" : "#28a745",
// //                   fontSize: '14px'
// //                 }}>
// //                   🔒 Ce quiz est {attemptOnce ? "limité à une seule tentative" : "rejouable"}.
// //                 </span>
// //               </div>
// //             </div>

// //             {/* PROGRESSION DÉTAILLÉE PROFESSIONNELLE */}
// //             <Card
// //               title={
// //                 <span style={{ fontSize: "18px", fontWeight: "bold", color: "#1890ff" }}>
// //                   <FileTextOutlined /> Résultats et progression
// //                 </span>
// //               }
// //               style={{
// //                 borderRadius: "16px",
// //                 boxShadow: "0 4px 20px rgba(0, 0, 0, 0.08)",
// //                 border: '1px solid #e9ecef'
// //               }}
// //             >
// //               {progress && progress.length > 0 ? (
// //                 <List
// //                   itemLayout="horizontal"
// //                   dataSource={progress}
// //                   renderItem={(item) => {
// //                     const pct = item.pct ?? 0;
// //                     const icon =
// //                       pct >= 80 ? (
// //                         <CheckCircleTwoTone twoToneColor="#52c41a" />
// //                       ) : pct >= 50 ? (
// //                         <InfoCircleTwoTone twoToneColor="#faad14" />
// //                       ) : (
// //                         <CloseCircleTwoTone twoToneColor="#ff4d4f" />
// //                       );

// //                     const color =
// //                       pct >= 80 ? "green" : pct >= 50 ? "orange" : "red";

// //                     return (
// //                       <List.Item
// //                         style={{
// //                           backgroundColor: "#fafafa",
// //                           marginBottom: "20px",
// //                           padding: "20px",
// //                           borderRadius: "12px",
// //                           boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
// //                           border: '1px solid #f0f0f0'
// //                         }}
// //                       >
// //                         <List.Item.Meta
// //                           avatar={icon}
// //                           title={
// //                             <span style={{ fontWeight: "bold", color: "#333", fontSize: '16px' }}>
// //                               Quiz N° : {item.quizId ?? "N/A"}
// //                             </span>
// //                           }
// //                           description={
// //                             <>
// //                               <Progress
// //                                 percent={pct}
// //                                 status={pct >= 80 ? "success" : pct >= 50 ? "active" : "exception"}
// //                                 strokeColor={color}
// //                                 style={{ marginBottom: '12px' }}
// //                               />
// //                               <Tag color={color} style={{ fontSize: '13px', padding: '4px 8px' }}>
// //                                 {item.scoreObtained ?? 0}/{item.scoreTotal ?? 0} points
// //                               </Tag>
// //                             </>
// //                           }
// //                         />
// //                       </List.Item>
// //                     );
// //                   }}
// //                 />
// //               ) : (
// //                 <div style={{ textAlign: "center", color: "#999", padding: '50px' }}>
// //                   <FileTextOutlined style={{ fontSize: '48px', marginBottom: '16px' }} />
// //                   <p>Aucune donnée de progression trouvée.</p>
// //                 </div>
// //               )}
// //             </Card>
// //           </div>
// //         )}

// //         {renderQuizSummaryModal()}
// //       </div>
// //     </div>
// //   );
// // };

// // export default TestDeConnaissance;



// import React, { useEffect, useState } from "react";
// import { Card, Checkbox, Radio, Divider, Badge, Tooltip, Spin, Alert, Steps, Button, Modal, List, Tag, Progress } from "antd";
// import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
// import courseService from "../../services/course.service";
// import MatchingQuestionViewer from "./MatchingQuestionViewer";
// import { CheckCircleTwoTone, FileTextOutlined, InfoCircleTwoTone, CloseCircleTwoTone, ClockCircleOutlined, TrophyOutlined, BookOutlined } from '@ant-design/icons';
// import { useDispatch } from "react-redux";
// import { recalculateNote } from "../../actions/noteActions";
// import DragDropZones from '../moderateur/quizes/DragDropZones';
// import DragDropImage from '../moderateur/quizes/drag_drop_images/DragDropImage';


// const { Step } = Steps;

// const TestDeConnaissance = ({ quizId, courseId, attemptOnce = false }) => {
//   const dispatch = useDispatch();

//   // ✅ TOUS LES STATES
//   const [quiz, setQuiz] = useState(null);
//   const [showIntroduction, setShowIntroduction] = useState(true);
//   const [questions, setQuestions] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [userAnswers, setUserAnswers] = useState({});
//   const [submitted, setSubmitted] = useState(false);
//   const [currentStep, setCurrentStep] = useState(0);
//   const [threshold, setThreshold] = useState(0);
//   const [isGeneratingBadge, setIsGeneratingBadge] = useState(false);
//   const [downloading, setDownloading] = useState(false);
//   const [reviewResults, setReviewResults] = useState([]);
//   const [showSummaryModal, setShowSummaryModal] = useState(false);
//   const [score, setScore] = useState(0);
//   const [myscore_stored, setmyscore_stored] = useState(0);
//   const [resultSaved, setResultSaved] = useState(false);
//   const [submitting, setSubmitting] = useState(false);
//   const [progress, setProgress] = useState([]);
//   const [refreshTrigger, setRefreshTrigger] = useState(0);
//   const questionsLoadedRef = React.useRef(false); // ✅ Empêche le double chargement/re-shuffle

//   // ✅ VARIABLES CALCULÉES
//   const totalPossibleScore = questions.reduce((sum, q) => sum + (q.score || 0), 0);
//   const isAttemptOnce = attemptOnce === true || attemptOnce === 1;
//   const storedUser = JSON.parse(localStorage.getItem("user"));
//   const userId = storedUser?.id || null;

//   // ✅ FONCTIONS UTILITAIRES
//   const shuffleArray = (array) => {
//     const shuffled = [...array];
//     for (let i = shuffled.length - 1; i > 0; i--) {
//       const j = Math.floor(Math.random() * (i + 1));
//       [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
//     }
//     return shuffled;
//   };

//   const isValidHtml = (html) => {
//     const div = document.createElement("div");
//     div.innerHTML = html;
//     return div.textContent.trim().length > 0;
//   };

//   const calculateScore = () => {
//     if (!submitted) return 0;
//     return questions.reduce((sum, q) => isCorrect(q) ? sum + (q.score || 0) : sum, 0);
//   };

//   // ✅ CORRECTION 3 : isCorrect avec cas DRAG_DROP séparé (comparaison position par position)
//   const isCorrect = (question) => {
//     const userAnswer = userAnswers[question.id];

//     if (question.questionType === "MATCHING") {
//       if (!userAnswer) return false;
//       return question.options.every(
//         (pair) => userAnswer[pair.leftText] === pair.rightText
//       );
//     }

//     if (question.questionType === "DRAG_DROP_IMAGE") {
//       if (!userAnswer || typeof userAnswer !== 'object') return false;
//       const zones = question.imageZones || [];
//       return zones.every((zone) => {
//         return userAnswer[zone.id.toString()] === zone.correctAnswer;
//       });
//     }

//     if (question.questionType === "DRAG_DROP_ZONES") {
//       if (!userAnswer || typeof userAnswer !== 'object') return false;
//       const zones = question.zones || [];
//       return zones.every((zone) => {
//         return userAnswer[zone.id.toString()] === zone.correctAnswer;
//       });
//     }

//     // ✅ DRAG_DROP : comparer position par position (l'ordre compte !)
//     if (question.questionType === "DRAG_DROP") {
//       if (!Array.isArray(userAnswer)) return false;
//       const correctOrder = question.correctAnswers || [];
//       if (userAnswer.length !== correctOrder.length) return false;
//       return userAnswer.every((text, index) => text === correctOrder[index]);
//     }

//     const correct = question.correctAnswers;
//     if (Array.isArray(userAnswer)) {
//       return JSON.stringify(userAnswer.sort()) === JSON.stringify(correct.sort());
//     }
//     return userAnswer === correct[0];
//   };

//   const handleStartQuiz = () => {
//     console.log("🚀 Démarrage du quiz - Masquage de l'introduction");
//     setShowIntroduction(false);
//   };

//   // ✅ Charger les infos du quiz
//   useEffect(() => {
//     const loadQuizInfo = async () => {
//       try {
//         console.log("📋 Chargement des infos du quiz ID:", quizId);
//         const quizData = await courseService.getQuizByIdWithIntro(quizId);
//         console.log("✅ Quiz chargé:", quizData);
//         setQuiz(quizData);
//         await checkExistingSubmission();
//       } catch (error) {
//         console.error("❌ Erreur lors du chargement du quiz :", error);
//         setError("Erreur lors du chargement du quiz.");
//       }
//     };

//     if (quizId) {
//       loadQuizInfo();
//     }
//   }, [quizId]);

//   // ✅ CORRECTION 1 : Charger les questions — DRAG_DROP correctAnswers = ordre backend (orderIndex)
//   // ✅ FIX : Ne pas recharger si les questions sont déjà chargées (évite re-shuffle)
//   useEffect(() => {
//     const loadQuiz = async () => {
//       if (!quiz) return;
//       if (questionsLoadedRef.current) {
//         console.log("⏭️ Questions déjà chargées, skip reload (évite re-shuffle)");
//         return;
//       }
//       questionsLoadedRef.current = true;

//       try {
//         console.log("📝 Chargement optimisé des questions du quiz:", quizId);
//         const questionList = await courseService.getQuestionsWithAnswers(quizId);

//         const questionsWithOptions = questionList.map((question) => {
//           if (question.questionType === "MATCHING") {
//             return { ...question, options: question.matchingPairs || [] };
//           }
//           else if (question.questionType === "DRAG_DROP_ZONES") {
//             return {
//               ...question,
//               zones: question.zones || [],
//               propositions: question.propositions || []
//             };
//           }
//           else if (question.questionType === "DRAG_DROP_IMAGE") {
//             return {
//               ...question,
//               imageZones: question.imageZones || [],
//               propositions: question.propositions || []
//             };
//           }
//           // ✅ CORRECTION DRAG_DROP : l'ordre correct = ordre du backend (trié par orderIndex)
//           else if (question.questionType === "DRAG_DROP") {
//             const options = question.answers || [];
//             // L'ordre correct = l'ordre venant du backend (déjà trié par orderIndex)
//             const correctOrder = options.map(opt => opt.text);
//             // Mélanger pour l'affichage étudiant
//             const shuffledOptions = shuffleArray(options);
//             return { ...question, options: shuffledOptions, correctAnswers: correctOrder };
//           }
//           else {
//             const options = question.answers || [];
//             const correctAnswers = options.filter(opt => opt.isCorrect || opt.correct).map(opt => opt.text);
//             return { ...question, options, correctAnswers };
//           }
//         });

//         setQuestions(questionsWithOptions);
//         console.log("✅ Questions traitées (optimisé):", questionsWithOptions.length);
//       } catch (err) {
//         console.error("Erreur chargement quiz:", err);
//         setError("Erreur lors du chargement du quiz.");
//       } finally {
//         setLoading(false);
//       }
//     };

//     loadQuiz();
//   }, [quiz, quizId, refreshTrigger]);

//   // 3️⃣ Lazy load des images
//   useEffect(() => {
//     const loadImageIfNeeded = async () => {
//       if (!questions.length) return;
//       const currentQ = questions[currentStep];

//       if (currentQ?.questionType === "DRAG_DROP_IMAGE" && !currentQ.imageLoaded) {
//         try {
//           console.log("🖼️ Lazy loading images pour question:", currentQ.id);
//           const imageData = await courseService.getQuestionImageData(currentQ.id);

//           setQuestions(prev => prev.map((q, idx) =>
//             idx === currentStep
//               ? { ...q, imageZones: imageData.imageZones, propositions: imageData.propositions, imageUrl: imageData.imageUrl, imageLoaded: true }
//               : q
//           ));
//           console.log("✅ Images chargées pour question:", currentQ.id);
//         } catch (err) {
//           console.error("❌ Erreur chargement images:", err);
//         }
//       }
//     };
//     loadImageIfNeeded();
//   }, [currentStep, questions.length]);

//   const checkExistingSubmission = async () => {
//     try {
//       const user = JSON.parse(localStorage.getItem("user"));
//       console.log("🔍 Vérification soumission existante pour userId:", user.id, "quizId:", quizId);

//       const review = await courseService.getQuizReviewResults(user.id, quizId);
//       console.log("📦 Review reçue:", review);

//       if (review && review.length > 0) {
//         console.log("⚠️ Quiz déjà soumis - Passage direct aux résultats");
//         const reconstructedAnswers = {};

//         review.forEach((question) => {
//           const type = question.questionType;
//           console.log(`📝 Reconstruction pour question ${question.questionId} - Type: ${type}`);

//           if (type === "QCU" || type === "VRAI_FAUX") {
//             reconstructedAnswers[question.questionId] = question.userAnswers[0]?.text || "";
//           }
//           else if (type === "QCM") {
//             reconstructedAnswers[question.questionId] = question.userAnswers.map(a => a.text);
//           }
//           else if (type === "MATCHING") {
//             const map = {};
//             question.userAnswers.forEach((a) => {
//               map[a.leftText] = a.rightText;
//             });
//             reconstructedAnswers[question.questionId] = map;
//           }
//           else if (type === "DRAG_DROP_IMAGE") {
//             const imageZoneAnswers = {};

//             if (question.imageZoneAnswers && Array.isArray(question.imageZoneAnswers)) {
//               console.log(`   🖼️ ${question.imageZoneAnswers.length} zones image trouvées`);
//               question.imageZoneAnswers.forEach((zone) => {
//                 const zoneId = zone.imageZoneId;
//                 const userAnswer = zone.userAnswer;

//                 if (zoneId !== null && zoneId !== undefined) {
//                   imageZoneAnswers[zoneId.toString()] = userAnswer;
//                   console.log(`   ✅ Zone image ${zoneId}: ${userAnswer}`);
//                 }
//               });
//             }

//             reconstructedAnswers[question.questionId] = imageZoneAnswers;
//             console.log(`   ✅ Réponses image reconstruites:`, imageZoneAnswers);
//           }
//           else if (type === "DRAG_DROP_ZONES") {
//             const zoneAnswers = {};

//             if (question.zoneAnswers && Array.isArray(question.zoneAnswers)) {
//               console.log(`   🎯 ${question.zoneAnswers.length} zones trouvées`);
//               question.zoneAnswers.forEach((zone) => {
//                 if (zone.zoneId !== null && zone.zoneId !== undefined) {
//                   zoneAnswers[zone.zoneId.toString()] = zone.userAnswer;
//                   console.log(`   Zone ${zone.zoneId}: ${zone.userAnswer}`);
//                 }
//               });
//             }

//             reconstructedAnswers[question.questionId] = zoneAnswers;
//             console.log(`   ✅ Réponses reconstruites:`, zoneAnswers);
//           }
//           // ✅ DRAG_DROP : reconstruire l'ordre de l'utilisateur
//           else if (type === "DRAG_DROP") {
//             if (question.userAnswers && Array.isArray(question.userAnswers)) {
//               console.log(`   📋 ${question.userAnswers.length} réponses DRAG_DROP trouvées`);
//               const orderedAnswers = question.userAnswers.map(answer => answer.text);
//               reconstructedAnswers[question.questionId] = orderedAnswers;
//               console.log(`   ✅ Réponses DRAG_DROP reconstruites:`, orderedAnswers);
//             } else {
//               console.error(`   ❌ userAnswers manquant pour DRAG_DROP`);
//               reconstructedAnswers[question.questionId] = [];
//             }
//           }
//         });

//         console.log("📊 Toutes les réponses reconstruites:", reconstructedAnswers);

//         setUserAnswers(reconstructedAnswers);
//         setSubmitted(true);
//         setResultSaved(true);
//         setShowIntroduction(false);

//         console.log("✅ États mis à jour - showIntroduction=false, submitted=true");
//       } else {
//         console.log("ℹ️ Review vide - Aucune soumission existante");
//       }
//     } catch (error) {
//       console.error("❌ Erreur dans checkExistingSubmission:", error);
//       if (error.response?.status !== 404) {
//         console.error("Response:", error.response?.data);
//       }
//     }
//   };

//   useEffect(() => {
//     const loadThreshold = async () => {
//       try {
//         if (!courseId) return;
//         const fetchedThreshold = await courseService.getThreshold(courseId);
//         console.log("🎯 Seuil récupéré du backend :", fetchedThreshold);
//         setThreshold(fetchedThreshold);
//       } catch (err) {
//         console.error("Erreur lors de la récupération du seuil :", err);
//       }
//     };
//     loadThreshold();
//   }, [courseId]);

//   useEffect(() => {
//     const loadProgress = async () => {
//       try {
//         if (!courseId || !userId) return;
//         const fetchedProgress = await courseService.CalculePrgresseByType(
//           "controle", courseId, userId, quizId
//         );
//         console.log("📊 Progression récupérée du backend :", fetchedProgress);
//         setProgress(fetchedProgress);
//       } catch (err) {
//         console.error("❌ Erreur lors de la récupération du progrès :", err);
//       }
//     };
//     loadProgress();
//   }, [courseId, userId, quizId, refreshTrigger]);

//   useEffect(() => {
//     const fetchReview = async () => {
//       if (!submitted || !quizId) return;

//       try {
//         const user = JSON.parse(localStorage.getItem("user"));
//         const review = await courseService.getQuizReviewResults(user.id, quizId);

//         console.log("🔁 REVIEW API - RÉPONSE COMPLÈTE");
//         console.log(JSON.stringify(review, null, 2));

//         review.forEach((q, index) => {
//           console.log(`\n📝 Question ${index + 1}:`, {
//             questionId: q.questionId,
//             questionType: q.questionType,
//             questionText: q.questionText,
//             score: q.score
//           });

//           if (q.questionType === "DRAG_DROP_ZONES") {
//             console.log("   🎯 zoneAnswers:", q.zoneAnswers);
//           } else if (q.questionType === "DRAG_DROP") {
//             console.log("   📋 userAnswers:", q.userAnswers);
//             console.log("   📋 correctAnswers:", q.correctAnswers);
//           }
//         });

//         setmyscore_stored(review[0].score);
//         setReviewResults(review);
//       } catch (error) {
//         console.error("❌ ERREUR lors du chargement de la review:", error.message);
//       }
//     };

//     fetchReview();
//   }, [submitted, quizId]);

//   const buildAnswersPayload = () => {
//     const answersArray = [];

//     console.log("\n🔨 CONSTRUCTION DU PAYLOAD");

//     questions.forEach((question, qIndex) => {
//       const userAnswer = userAnswers[question.id];

//       console.log(`\n📝 Question ${qIndex + 1} (ID: ${question.id}) - ${question.questionType}`);
//       console.log(`   Réponse brute:`, userAnswer);

//       // ✅ CAS 1 : Réponse simple (QCU, VRAI_FAUX)
//       if (typeof userAnswer === "string") {
//         const answer = question.options.find((opt) => opt.text === userAnswer);
//         if (answer) {
//           answersArray.push({ questionId: question.id, answerId: answer.id });
//           console.log(`   ✅ Ajouté: answerId=${answer.id}`);
//         }
//       }

//       // ✅ CAS 2 : DRAG_DROP (ordre important) - DOIT ÊTRE AVANT le cas Array générique
//       else if (question.questionType === "DRAG_DROP" && Array.isArray(userAnswer)) {
//         console.log(`   📋 Type DRAG_DROP détecté - Ordre: ${userAnswer.length} éléments`);
//         userAnswer.forEach((answerText, orderIndex) => {
//           const answer = question.options.find((opt) => opt.text === answerText);
//           if (answer) {
//             answersArray.push({ questionId: question.id, answerId: answer.id });
//             console.log(`   ✅ Position ${orderIndex + 1}: answerId=${answer.id} ("${answerText}")`);
//           }
//         });
//       }

//       // ✅ CAS 3 : QCM (ordre pas important)
//       else if (Array.isArray(userAnswer)) {
//         userAnswer.forEach((answerText) => {
//           const answer = question.options.find((opt) => opt.text === answerText);
//           if (answer) {
//             answersArray.push({ questionId: question.id, answerId: answer.id });
//           }
//         });
//       }

//       // ✅ CAS 4 : DRAG_DROP_IMAGE
//       else if (question.questionType === "DRAG_DROP_IMAGE" && typeof userAnswer === "object") {
//         const zones = question.imageZones || [];
//         const propositions = question.propositions || [];

//         Object.entries(userAnswer).forEach(([zoneId, content]) => {
//           const proposition = propositions.find(p =>
//             p.propositionContent === content || p.content === content || p.text === content
//           );
//           const zone = zones.find(z => z.id.toString() === zoneId);

//           if (proposition && zone) {
//             answersArray.push({
//               questionId: question.id,
//               imageZoneId: zone.id,
//               propositionId: proposition.id,
//             });
//           }
//         });
//       }

//       // ✅ CAS 5 : DRAG_DROP_ZONES
//       else if (question.questionType === "DRAG_DROP_ZONES" && typeof userAnswer === "object") {
//         const zones = question.zones || [];
//         const propositions = question.propositions || [];

//         Object.entries(userAnswer).forEach(([zoneId, content]) => {
//           const proposition = propositions.find(p =>
//             p.propositionContent === content || p.content === content || p.text === content
//           );
//           const zone = zones.find(z => z.id.toString() === zoneId);

//           if (proposition && zone) {
//             answersArray.push({
//               questionId: question.id,
//               zoneId: zone.id,
//               propositionId: proposition.id,
//             });
//           }
//         });
//       }

//       // ✅ CAS 6 : MATCHING
//       else if (question.questionType === "MATCHING" && typeof userAnswer === "object") {
//         const pairs = question.options || [];
//         pairs.forEach((pair) => {
//           const selected = userAnswer[pair.leftText];
//           const answer = question.options.find(
//             (opt) => opt.leftText === pair.leftText && opt.rightText === selected
//           );
//           if (answer && answer.id) {
//             answersArray.push({ questionId: question.id, answerId: answer.id });
//           }
//         });
//       }
//     });

//     console.log(`📦 PAYLOAD FINAL: ${answersArray.length} réponses`);
//     return answersArray;
//   };

//   const handleSubmit = async () => {
//     setSubmitting(true);

//     const scoreNow = questions.reduce(
//       (sum, q) => (isCorrect(q) ? sum + (q.score || 0) : sum), 0
//     );
//     setScore(scoreNow);

//     try {
//       const user = JSON.parse(localStorage.getItem("user"));
//       const payload = buildAnswersPayload();

//       console.log("🚀 Envoi de la requête au backend...");
//       const response = await courseService.submitQuizResult({
//         userId: user.id,
//         quizId: quizId,
//         scoreObtained: scoreNow,
//         scoreTotal: totalPossibleScore,
//         answers: payload,
//       });

//       console.log("✅ Résultat du quiz soumis avec succès.");
//       setResultSaved(true);
//       setSubmitted(true);
//       setRefreshTrigger(prev => prev + 1);
//       dispatch(recalculateNote(courseId, user.id));

//     } catch (error) {
//       console.error("❌ ERREUR LORS DE LA SOUMISSION:", error.message);
//       alert("Une erreur est survenue lors de l'enregistrement du score: " +
//         (error.response?.data?.message || error.message));
//     } finally {
//       setSubmitting(false);
//     }
//   };

//   // ✅ CORRECTION 2 : DragDropPreview avec feedback position par position
//   const DragDropPreview = ({ question }) => {
//     const existingAnswer = userAnswers[question.id];

//     const getInitialItems = () => {
//       if (existingAnswer && Array.isArray(existingAnswer)) {
//         return existingAnswer.map((text, index) => ({
//           id: `option-${index}`,
//           content: text,
//         }));
//       }
//       return question.options.map((opt, index) => ({
//         id: `option-${index}`,
//         content: opt.text,
//       }));
//     };

//     const [items, setItems] = useState(getInitialItems);

//     const onDragEnd = (result) => {
//       if (!result.destination || submitted) return;

//       const reordered = Array.from(items);
//       const [moved] = reordered.splice(result.source.index, 1);
//       reordered.splice(result.destination.index, 0, moved);
//       setItems(reordered);

//       const orderedTexts = reordered.map(item => item.content);
//       setUserAnswers({
//         ...userAnswers,
//         [question.id]: orderedTexts
//       });
//       console.log("✅ Ordre sauvegardé:", orderedTexts);
//     };

//     // Déterminer si chaque position est correcte
//     const getPositionStatus = (index) => {
//       if (!submitted) return null;
//       const userAnswer = userAnswers[question.id] || [];
//       const correctOrder = question.correctAnswers || [];
//       if (index >= userAnswer.length || index >= correctOrder.length) return null;
//       return userAnswer[index] === correctOrder[index];
//     };

//     return (
//       <div style={{ backgroundColor: "#f1f8e9", padding: "16px", borderRadius: "10px" }}>
//         <DragDropContext onDragEnd={onDragEnd}>
//           <Droppable droppableId="droppable-options">
//             {(provided) => (
//               <ul
//                 {...provided.droppableProps}
//                 ref={provided.innerRef}
//                 style={{ listStyleType: "none", paddingLeft: 0 }}
//               >
//                 {items.map((item, index) => {
//                   const positionCorrect = getPositionStatus(index);
//                   let backgroundColor = "#e8f5e9";
//                   if (submitted && positionCorrect !== null) {
//                     backgroundColor = positionCorrect ? "#c8e6c9" : "#ffcdd2";
//                   }

//                   return (
//                     <Draggable
//                       key={item.id}
//                       draggableId={item.id}
//                       index={index}
//                       isDragDisabled={submitted}
//                     >
//                       {(provided, snapshot) => (
//                         <li
//                           ref={provided.innerRef}
//                           {...provided.draggableProps}
//                           {...provided.dragHandleProps}
//                           style={{
//                             padding: "12px 16px",
//                             marginBottom: "8px",
//                             backgroundColor: snapshot.isDragging ? "#c8e6c9" : backgroundColor,
//                             border: snapshot.isDragging
//                               ? "2px solid #66bb6a"
//                               : submitted
//                                 ? `1px solid ${positionCorrect ? '#4caf50' : '#f44336'}`
//                                 : "1px solid #e0e0e0",
//                             borderRadius: "8px",
//                             cursor: submitted ? "default" : "grab",
//                             display: "flex",
//                             alignItems: "center",
//                             justifyContent: "space-between",
//                             transition: "all 0.2s ease",
//                             ...provided.draggableProps.style,
//                           }}
//                         >
//                           <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
//                             <Badge
//                               count={index + 1}
//                               style={{
//                                 backgroundColor: submitted
//                                   ? (positionCorrect ? '#52c41a' : '#ff4d4f')
//                                   : '#1890ff',
//                                 fontSize: '12px'
//                               }}
//                             />
//                             <span style={{ fontSize: "15px" }}>{item.content}</span>
//                           </div>

//                           {submitted && positionCorrect !== null && (
//                             <span style={{ fontSize: "18px" }}>
//                               {positionCorrect ? "✅" : "❌"}
//                             </span>
//                           )}
//                         </li>
//                       )}
//                     </Draggable>
//                   );
//                 })}
//                 {provided.placeholder}
//               </ul>
//             )}
//           </Droppable>
//         </DragDropContext>

//         {/* Afficher l'ordre correct après soumission si des erreurs */}
//         {submitted && question.correctAnswers && (() => {
//           const userAnswer = userAnswers[question.id] || [];
//           const hasErrors = question.correctAnswers.some((ans, i) => ans !== userAnswer[i]);
//           if (!hasErrors) return null;
//           return (
//             <div style={{
//               marginTop: "16px",
//               padding: "12px",
//               background: "#fff3cd",
//               borderRadius: "8px",
//               border: "1px solid #ffc107"
//             }}>
//               <strong style={{ color: "#856404" }}>📋 Ordre correct :</strong>
//               <ol style={{ marginTop: "8px", marginBottom: 0, paddingLeft: "20px" }}>
//                 {question.correctAnswers.map((answer, idx) => (
//                   <li key={idx} style={{ color: "#856404", marginBottom: "4px" }}>
//                     {answer}
//                   </li>
//                 ))}
//               </ol>
//             </div>
//           );
//         })()}
//       </div>
//     );
//   };


//   const renderQuestion = (question) => {
//     const userAnswer = userAnswers[question.id];

//     if (question.questionType === "QCU" || question.questionType === "VRAI_FAUX") {
//       return (
//         <div style={{
//           display: question.imageUrl ? 'grid' : 'block',
//           gridTemplateColumns: question.imageUrl ? '1fr 1fr' : '1fr',
//           gap: '20px',
//           alignItems: 'start'
//         }}>
//           <Radio.Group
//             value={userAnswer}
//             onChange={(e) => setUserAnswers({ ...userAnswers, [question.id]: e.target.value })}
//             disabled={submitted}
//             style={{ display: "flex", flexDirection: "column", gap: "12px" }}
//           >
//             {(question.options || []).map((option, i) => {
//               const isSelected = userAnswer === option.text;
//               const isCorrectAnswer = question.correctAnswers?.includes(option.text);
//               const showFeedback = submitted;

//               let backgroundColor = "transparent";
//               if (showFeedback) {
//                 if (isCorrectAnswer) backgroundColor = "#e8f5e9";
//                 else if (isSelected && !isCorrectAnswer) backgroundColor = "#ffebee";
//               }

//               return (
//                 <Radio
//                   key={i}
//                   value={option.text}
//                   style={{
//                     backgroundColor,
//                     borderRadius: "8px",
//                     padding: "12px 16px",
//                     display: "flex",
//                     alignItems: "center",
//                     border: "1px solid #e0e0e0",
//                     transition: "all 0.2s ease"
//                   }}
//                 >
//                   <span style={{ fontSize: "15px" }}>{option.text}</span>
//                   {showFeedback && isCorrectAnswer && (
//                     <span style={{ marginLeft: "12px", color: "green", fontSize: "18px" }}>✅</span>
//                   )}
//                   {showFeedback && isSelected && !isCorrectAnswer && (
//                     <span style={{ marginLeft: "12px", color: "red", fontSize: "18px" }}>❌</span>
//                   )}
//                 </Radio>
//               );
//             })}
//           </Radio.Group>

//           {question.imageUrl && (
//             <div style={{
//               borderRadius: '12px',
//               overflow: 'hidden',
//               border: '2px solid #e9ecef',
//               background: '#fafafa',
//               position: 'relative',
//               boxShadow: '0 4px 15px rgba(0, 0, 0, 0.08)'
//             }}>
//               <div style={{
//                 position: 'absolute', top: '10px', left: '10px',
//                 background: 'rgba(0, 0, 0, 0.6)', color: 'white',
//                 padding: '4px 10px', borderRadius: '6px', fontSize: '11px',
//                 fontWeight: '500', zIndex: 1, backdropFilter: 'blur(4px)'
//               }}>
//                 🖼️ Illustration
//               </div>
//               <img
//                 src={question.imageUrl}
//                 alt="Illustration de la question"
//                 style={{ width: '100%', display: 'block', objectFit: 'contain', maxHeight: '400px' }}
//               />
//             </div>
//           )}
//         </div>
//       );
//     }

//     if (question.questionType === "QCM") {
//       const selectedAnswers = userAnswer || [];
//       return (
//         <div style={{
//           display: question.imageUrl ? 'grid' : 'block',
//           gridTemplateColumns: question.imageUrl ? '1fr 1fr' : '1fr',
//           gap: '20px',
//           alignItems: 'start'
//         }}>
//           <Checkbox.Group
//             value={selectedAnswers}
//             onChange={(values) => setUserAnswers({ ...userAnswers, [question.id]: values })}
//             disabled={submitted}
//             style={{ display: "flex", flexDirection: "column", gap: "12px" }}
//           >
//             {(question.options || []).map((option, i) => {
//               const isSelected = selectedAnswers.includes(option.text);
//               const isCorrectAnswer = question.correctAnswers?.includes(option.text);
//               const showFeedback = submitted;

//               let backgroundColor = "transparent";
//               if (showFeedback) {
//                 if (isCorrectAnswer) backgroundColor = "#e8f5e9";
//                 else if (isSelected && !isCorrectAnswer) backgroundColor = "#ffebee";
//               }

//               return (
//                 <Checkbox
//                   key={i}
//                   value={option.text}
//                   style={{
//                     backgroundColor,
//                     borderRadius: "8px",
//                     padding: "12px 16px",
//                     display: "flex",
//                     alignItems: "center",
//                     border: "1px solid #e0e0e0",
//                     transition: "all 0.2s ease"
//                   }}
//                 >
//                   <span style={{ fontSize: "15px" }}>{option.text}</span>
//                   {showFeedback && isCorrectAnswer && (
//                     <span style={{ marginLeft: "12px", color: "green", fontSize: "18px" }}>✅</span>
//                   )}
//                   {showFeedback && isSelected && !isCorrectAnswer && (
//                     <span style={{ marginLeft: "12px", color: "red", fontSize: "18px" }}>❌</span>
//                   )}
//                 </Checkbox>
//               );
//             })}
//           </Checkbox.Group>

//           {question.imageUrl && (
//             <div style={{
//               borderRadius: '12px', overflow: 'hidden',
//               border: '2px solid #e9ecef', background: '#fafafa',
//               position: 'relative', boxShadow: '0 4px 15px rgba(0, 0, 0, 0.08)'
//             }}>
//               <div style={{
//                 position: 'absolute', top: '10px', left: '10px',
//                 background: 'rgba(0, 0, 0, 0.6)', color: 'white',
//                 padding: '4px 10px', borderRadius: '6px', fontSize: '11px',
//                 fontWeight: '500', zIndex: 1, backdropFilter: 'blur(4px)'
//               }}>
//                 🖼️ Illustration
//               </div>
//               <img
//                 src={question.imageUrl}
//                 alt="Illustration de la question"
//                 style={{ width: '100%', display: 'block', objectFit: 'contain', maxHeight: '400px' }}
//               />
//             </div>
//           )}
//         </div>
//       );
//     }

//     if (question.questionType === "DRAG_DROP") {
//       return <DragDropPreview key={`dragdrop-${question.id}`} question={question} />;
//     }

//     if (question.questionType === "DRAG_DROP_IMAGE") {
//       const zones = (question.imageZones || []).map(zone => ({
//         id: zone.id, label: zone.zoneLabel, correctAnswer: zone.correctAnswer,
//         x: zone.posX, y: zone.posY, width: zone.width, height: zone.height
//       }));

//       const propositions = (question.propositions || []).map(prop => ({
//         id: prop.id, content: prop.propositionContent || prop.content || prop.text
//       }));

//       const handleAnswerChange = (answer) => {
//         const isZoneMapping = typeof answer === 'object' && !answer.zoneId && !answer.content;

//         if (isZoneMapping) {
//           const newAnswers = { ...(userAnswer || {}), ...answer };
//           setUserAnswers({ ...userAnswers, [question.id]: newAnswers });
//           return;
//         }

//         const newAnswers = { ...(userAnswer || {}), [answer.zoneId]: answer.content };
//         setUserAnswers({ ...userAnswers, [question.id]: newAnswers });
//       };

//       return (
//         <DragDropImage
//           imageUrl={question.imageUrl}
//           dropZones={zones}
//           propositions={propositions}
//           onAnswerChange={handleAnswerChange}
//           showCorrectAnswers={submitted}
//           initialFilledZones={userAnswer || {}}
//         />
//       );
//     }

//     if (question.questionType === "MATCHING") {
//       return (
//         <MatchingQuestionViewer
//           key={submitted + JSON.stringify(userAnswers[question.id] || {})}
//           pairs={question.options || []}
//           questionId={question.id}
//           userAnswers={userAnswers}
//           setUserAnswers={setUserAnswers}
//           disabled={submitted}
//         />
//       );
//     }

//     if (question.questionType === "DRAG_DROP_ZONES") {
//       const zones = (question.zones || []).map(zone => ({
//         id: zone.id.toString(), label: zone.zoneLabel || zone.label, correctAnswer: zone.correctAnswer
//       }));

//       const propositions = (question.propositions || []).map(prop => ({
//         id: prop.id.toString(), content: prop.propositionContent || prop.content || prop.text
//       }));

//       const handleAnswerChange = (answer) => {
//         if (typeof answer === 'object' && !answer.zoneId) {
//           setUserAnswers({ ...userAnswers, [question.id]: answer });
//           return;
//         }

//         const newAnswers = { ...(userAnswer || {}), [answer.zoneId]: answer.content };
//         setUserAnswers({ ...userAnswers, [question.id]: newAnswers });
//       };

//       return (
//         <DragDropZones
//           zones={zones}
//           propositions={propositions}
//           onAnswerChange={handleAnswerChange}
//           showCorrectAnswers={false}
//           initialFilledZones={userAnswer || {}}
//         />
//       );
//     }

//     return <p style={{ color: "red" }}>❗ Type non supporté : {question.questionType}</p>;
//   };

//   // ✅ FONCTION POUR RENDRE L'INTRODUCTION PROFESSIONNELLE
//   const renderIntroduction = () => (
//     <div
//       style={{
//         minHeight: '100vh',
//         background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)',
//         display: 'flex', alignItems: 'center', justifyContent: 'center',
//         padding: '20px', fontFamily: "'Segoe UI', 'Roboto', sans-serif"
//       }}
//     >
//       <div style={{
//         background: '#ffffff', borderRadius: '16px', padding: '0',
//         maxWidth: '1200px', width: '100%',
//         boxShadow: '0 20px 60px rgba(0, 0, 0, 0.1)', overflow: 'hidden'
//       }}>
//         {/* HEADER */}
//         <div style={{
//           background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
//           color: 'white', padding: '30px 40px',
//           display: 'flex', justifyContent: 'space-between', alignItems: 'center'
//         }}>
//           <div>
//             <div style={{ fontSize: '12px', textTransform: 'uppercase', letterSpacing: '1px', opacity: '0.9', marginBottom: '8px' }}>
//               {quiz?.linkType === 'evaluation' ? 'ÉVALUATION' : 'CONTRÔLE DE CONNAISSANCES'}
//             </div>
//             <h1 style={{ fontSize: '28px', fontWeight: '700', margin: '0', lineHeight: '1.2' }}>
//               {quiz?.title || 'Test de connaissances'}
//             </h1>
//           </div>
//           <div style={{ textAlign: 'right', fontSize: '14px', opacity: '0.9' }}>
//             <div>{quiz?.course?.title || 'Cours en ligne'}</div>
//           </div>
//         </div>

//         {/* CONTENU */}
//         <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr', gap: '0' }}>
//           <div style={{ padding: '40px' }}>
//             <h2 style={{ fontSize: '20px', fontWeight: '600', color: '#2c3e50', marginBottom: '20px', borderBottom: '2px solid #e9ecef', paddingBottom: '10px' }}>
//               📋 Présentation du contrôle
//             </h2>

//             {quiz?.introductionText && quiz.introductionText.trim() !== '' ? (
//               <div
//                 style={{ fontSize: '15px', lineHeight: '1.7', color: '#495057', background: '#f8f9fa', padding: '25px', borderRadius: '12px', border: '1px solid #e9ecef' }}
//                 dangerouslySetInnerHTML={{ __html: quiz.introductionText }}
//               />
//             ) : (
//               <div style={{ fontSize: '15px', lineHeight: '1.7', color: '#6c757d', fontStyle: 'italic' }}>
//                 Ce contrôle évalue vos connaissances sur les sujets abordés dans le cours.
//               </div>
//             )}

//             <div style={{ marginTop: '30px' }}>
//               <h3 style={{ fontSize: '16px', fontWeight: '600', color: '#2c3e50', marginBottom: '15px' }}>🎯 Instructions</h3>
//               <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px', fontSize: '14px', color: '#495057' }}>
//                 <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}><span>📖</span><span>Lisez chaque question attentivement</span></div>
//                 <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}><span>🤔</span><span>Réfléchissez avant de répondre</span></div>
//                 <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}><span>⏰</span><span>Gérez votre temps efficacement</span></div>
//                 <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}><span>✅</span><span>Vérifiez vos réponses</span></div>
//               </div>
//             </div>
//           </div>

//           <div style={{ background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)', padding: '40px 30px', borderLeft: '1px solid #e9ecef' }}>
//             <div style={{ background: 'white', borderRadius: '12px', padding: '25px', marginBottom: '25px', boxShadow: '0 4px 15px rgba(0, 0, 0, 0.05)' }}>
//               <h3 style={{ fontSize: '16px', fontWeight: '600', color: '#2c3e50', marginBottom: '20px', textAlign: 'center' }}>📊 Informations</h3>
//               <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
//                 <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px 15px', background: '#f8f9fa', borderRadius: '8px' }}>
//                   <span style={{ color: '#6c757d', fontSize: '14px' }}><BookOutlined style={{ marginRight: '8px', color: '#1976d2' }} />Questions</span>
//                   <strong style={{ color: '#1976d2', fontSize: '16px' }}>{questions.length}</strong>
//                 </div>
//                 <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px 15px', background: '#f8f9fa', borderRadius: '8px' }}>
//                   <span style={{ color: '#6c757d', fontSize: '14px' }}><TrophyOutlined style={{ marginRight: '8px', color: '#388e3c' }} />Points</span>
//                   <strong style={{ color: '#388e3c', fontSize: '16px' }}>{totalPossibleScore}</strong>
//                 </div>
//                 <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px 15px', background: '#f8f9fa', borderRadius: '8px' }}>
//                   <span style={{ color: '#6c757d', fontSize: '14px' }}><ClockCircleOutlined style={{ marginRight: '8px', color: '#f57c00' }} />Durée estimée</span>
//                   <strong style={{ color: '#f57c00', fontSize: '16px' }}>~{Math.ceil(questions.length * 1.5)} min</strong>
//                 </div>
//               </div>
//             </div>

//             <div style={{
//               background: quiz?.attemptOnce ? '#fff3cd' : '#d1ecf1',
//               border: `1px solid ${quiz?.attemptOnce ? '#ffeaa7' : '#bee5eb'}`,
//               borderRadius: '12px', padding: '20px', textAlign: 'center'
//             }}>
//               <div style={{ fontSize: '14px', fontWeight: '600', color: quiz?.attemptOnce ? '#856404' : '#0c5460', marginBottom: '8px' }}>
//                 {quiz?.attemptOnce ? '⚠️ TENTATIVE UNIQUE' : '✅ TENTATIVES MULTIPLES'}
//               </div>
//               <div style={{ fontSize: '13px', color: quiz?.attemptOnce ? '#856404' : '#0c5460', lineHeight: '1.4' }}>
//                 {quiz?.attemptOnce
//                   ? 'Vous n\'aurez qu\'une seule chance. Assurez-vous d\'être prêt !'
//                   : 'Vous pouvez refaire ce quiz autant de fois que nécessaire.'}
//               </div>
//             </div>

//             <Button
//               type="primary" size="large" onClick={handleStartQuiz}
//               style={{
//                 width: '100%', height: '50px', marginTop: '25px', fontSize: '16px', fontWeight: '600',
//                 background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
//                 border: 'none', borderRadius: '12px', boxShadow: '0 4px 15px rgba(102, 126, 234, 0.4)'
//               }}
//             >
//               🚀 Commencer le contrôle
//             </Button>
//           </div>
//         </div>
//       </div>
//     </div>
//   );

//   const renderQuizSummaryModal = () => (
//     <Modal
//       title={
//         <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
//           <FileTextOutlined style={{ color: "#1890ff", fontSize: 20 }} />
//           <span style={{ fontSize: "18px", fontWeight: 600 }}>Résumé de vos réponses</span>
//         </div>
//       }
//       open={showSummaryModal}
//       onCancel={() => setShowSummaryModal(false)}
//       onOk={async () => { setShowSummaryModal(false); await handleSubmit(); }}
//       okText="✅ Confirmer l'envoi"
//       cancelText="✖️ Modifier mes réponses"
//       okButtonProps={{ type: "primary" }}
//       width={650}
//     >
//       <Divider style={{ margin: "10px 0 20px 0" }} />
//       <List
//         dataSource={questions}
//         renderItem={(question, index) => {
//           const userAnswer = userAnswers[question.id];
//           const userText = Array.isArray(userAnswer)
//             ? userAnswer.join(", ")
//             : typeof userAnswer === "object"
//               ? "[Réponse structurée]"
//               : userAnswer || "Non répondu";

//           return (
//             <List.Item
//               style={{
//                 backgroundColor: "#f9f9f9", borderLeft: "6px solid #1890ff",
//                 padding: "14px 18px", borderRadius: "10px", marginBottom: 10,
//                 transition: "transform 0.2s ease",
//               }}
//               onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.01)")}
//               onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
//             >
//               <List.Item.Meta
//                 title={
//                   <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
//                     <Badge count={`Q${index + 1}`} style={{ backgroundColor: "#1890ff", fontWeight: 600 }} />
//                     <span style={{ fontWeight: 500 }}>{question.text}</span>
//                   </div>
//                 }
//                 description={<div style={{ marginTop: 4 }}><strong>Votre réponse :</strong> {userText}</div>}
//               />
//             </List.Item>
//           );
//         }}
//       />
//       <Divider />
//       <div style={{ textAlign: "center", color: "#888", fontSize: 13 }}>
//         <InfoCircleTwoTone twoToneColor="#1890ff" /> Vérifiez vos réponses avant l'envoi définitif.
//       </div>
//     </Modal>
//   );

//   // ✅ CONDITIONS DE RETOUR
//   if (loading) {
//     return (
//       <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)' }}>
//         <div style={{ background: 'white', padding: '40px', borderRadius: '20px', textAlign: 'center', boxShadow: '0 20px 60px rgba(0, 0, 0, 0.15)' }}>
//           <Spin size="large" />
//           <p style={{ marginTop: '20px', fontSize: '16px', color: '#666' }}>Chargement du quiz...</p>
//         </div>
//       </div>
//     );
//   }

//   if (error) {
//     return (
//       <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)', padding: '20px' }}>
//         <Alert message="Erreur" description={error} type="error" showIcon style={{ maxWidth: '500px' }} />
//       </div>
//     );
//   }

//   if (showIntroduction && quiz) {
//     return renderIntroduction();
//   }

//   if (!questions[currentStep]) {
//     return (
//       <div style={{ textAlign: 'center', padding: '50px' }}>
//         <Alert message="Question non trouvée." type="error" />
//       </div>
//     );
//   }

//   // ✅ RENDU PRINCIPAL
//   return (
//     <div style={{ minHeight: '100vh', background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)', padding: '20px' }}>
//       <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
//         {/* HEADER */}
//         <div style={{
//           background: 'white', borderRadius: '16px', padding: '25px 30px',
//           marginBottom: '25px', boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)', border: '1px solid #e9ecef'
//         }}>
//           <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
//             <div>
//               <div style={{ fontSize: '12px', textTransform: 'uppercase', letterSpacing: '1px', color: '#6c757d', marginBottom: '5px' }}>
//                 {quiz?.linkType === 'evaluation' ? 'ÉVALUATION' : 'CONTRÔLE DE CONNAISSANCES'}
//               </div>
//               <h2 style={{ margin: 0, fontSize: '24px', fontWeight: '700', color: '#2c3e50' }}>
//                 {quiz?.title || 'Quiz'}
//               </h2>
//             </div>
//             {submitted && (
//               <div style={{
//                 background: 'linear-gradient(135deg, #28a745, #20c997)', color: 'white',
//                 padding: '12px 20px', borderRadius: '12px', fontSize: '16px', fontWeight: '600',
//                 display: 'flex', alignItems: 'center', gap: '8px'
//               }}>
//                 <TrophyOutlined /> Score : {calculateScore()} / {totalPossibleScore}
//               </div>
//             )}
//           </div>

//           <Steps current={currentStep} onChange={(step) => submitted && setCurrentStep(step)} size="small">
//             {questions.map((q, index) => {
//               const correct = isCorrect(q);
//               const isActive = currentStep === index;
//               const icon = submitted ? (
//                 correct ? <CheckCircleTwoTone twoToneColor="#52c41a" /> : <CloseCircleTwoTone twoToneColor="#ff4d4f" />
//               ) : undefined;

//               return (
//                 <Step key={q.id} icon={icon} title={
//                   <span style={{
//                     fontWeight: isActive ? "bold" : "normal",
//                     color: submitted ? correct ? "#52c41a" : "#ff4d4f" : isActive ? "#1890ff" : undefined
//                   }}>Q{index + 1}</span>
//                 } />
//               );
//             })}
//           </Steps>
//         </div>

//         {/* CARTE DE QUESTION */}
//         <Card
//           title={
//             <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//               <span style={{ fontSize: '18px', fontWeight: '600', color: '#2c3e50' }}>
//                 Question {currentStep + 1} : {questions[currentStep].text || "Sans titre"}
//               </span>
//               <Tag color="blue" style={{ fontSize: '14px', padding: '4px 12px' }}>
//                 {questions[currentStep].score || 0} pts
//               </Tag>
//             </div>
//           }
//           style={{ marginBottom: "25px", borderRadius: '16px', boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)', border: '1px solid #e9ecef' }}
//           bodyStyle={{ padding: '30px' }}
//         >
//           {renderQuestion(questions[currentStep])}

//           {submitted && (
//             <div style={{
//               marginTop: "25px", padding: "20px",
//               backgroundColor: isCorrect(questions[currentStep]) ? "#e8f5e9" : "#ffebee",
//               borderRadius: "12px",
//               border: `2px solid ${isCorrect(questions[currentStep]) ? "#4caf50" : "#f44336"}`
//             }}>
//               <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '12px' }}>
//                 <span style={{ fontSize: '22px', color: isCorrect(questions[currentStep]) ? "#2e7d32" : "#c62828" }}>
//                   {isCorrect(questions[currentStep]) ? "✔️" : "❌"}
//                 </span>
//                 <strong style={{ color: isCorrect(questions[currentStep]) ? "#2e7d32" : "#c62828", fontSize: '16px' }}>
//                   {isCorrect(questions[currentStep]) ? "Excellente réponse !" : "Réponse incorrecte"}
//                 </strong>
//               </div>

//               {questions[currentStep].explanation && isValidHtml(questions[currentStep].explanation) && (
//                 <div style={{ marginTop: "15px", padding: '15px', background: 'rgba(255, 255, 255, 0.9)', borderRadius: '8px', border: '1px solid rgba(0, 0, 0, 0.1)' }}>
//                   <strong style={{ color: '#5d4037', fontSize: '15px' }}>💡 Explication :</strong>
//                   <div style={{ marginTop: '8px' }}>
//                     <span dangerouslySetInnerHTML={{ __html: questions[currentStep].explanation }} />
//                   </div>
//                 </div>
//               )}
//             </div>
//           )}
//         </Card>

//         {/* NAVIGATION */}
//         <div style={{
//           background: 'white', borderRadius: '16px', padding: '25px 30px',
//           display: 'flex', justifyContent: 'space-between', alignItems: 'center',
//           boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)', border: '1px solid #e9ecef'
//         }}>
//           <Button
//             onClick={() => setCurrentStep((prev) => prev - 1)}
//             disabled={currentStep === 0}
//             size="large"
//             style={{ minWidth: '140px', borderRadius: '8px', fontWeight: '500' }}
//           >
//             ← Précédent
//           </Button>

//           <div style={{ display: 'flex', alignItems: 'center', gap: '15px', background: '#f8f9fa', padding: '12px 20px', borderRadius: '8px' }}>
//             <span style={{ color: '#6c757d', fontSize: '14px', fontWeight: '500' }}>
//               Question {currentStep + 1} sur {questions.length}
//             </span>
//             <Progress percent={((currentStep + 1) / questions.length) * 100} showInfo={false} style={{ width: '120px' }} strokeColor="#667eea" />
//           </div>

//           {currentStep < questions.length - 1 ? (
//             <Button
//               onClick={() => setCurrentStep((prev) => prev + 1)}
//               type="primary" size="large"
//               style={{ minWidth: '140px', borderRadius: '8px', fontWeight: '500', background: '#667eea' }}
//             >
//               Suivant →
//             </Button>
//           ) : (
//             !submitted && (
//               <Button
//                 type="primary"
//                 onClick={() => setShowSummaryModal(true)}
//                 loading={submitting}
//                 disabled={submitting}
//                 size="large"
//                 style={{
//                   minWidth: '180px', borderRadius: '8px', fontWeight: '600',
//                   background: submitting ? "#6c757d" : 'linear-gradient(135deg, #28a745, #20c997)',
//                   border: 'none'
//                 }}
//               >
//                 {submitting ? "Envoi en cours..." : "🚀 Soumettre le quiz"}
//               </Button>
//             )
//           )}
//         </div>

//         {/* RÉSULTATS */}
//         {submitted && (
//           <div style={{ marginTop: '30px' }}>
//             <div style={{
//               background: 'white', borderRadius: '16px', padding: '30px', textAlign: 'center',
//               boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)', marginBottom: '25px', border: '1px solid #e9ecef'
//             }}>
//               <div style={{ marginBottom: '25px' }}>
//                 <Button
//                   type="default"
//                   disabled={attemptOnce}
//                   onClick={() => {
//                     if (!attemptOnce) {
//                       setSubmitted(false);
//                       setUserAnswers({});
//                       setCurrentStep(0);
//                       setQuestions([]); // ✅ Reset questions pour forcer un nouveau shuffle
//                       questionsLoadedRef.current = false; // ✅ Permettre le rechargement
//                       setRefreshTrigger(prev => prev + 1); // ✅ Déclencher le useEffect
//                     }
//                   }}
//                   style={{ marginRight: '15px', borderRadius: '8px', fontWeight: '500' }}
//                   size="large"
//                 >
//                   🔄 Recommencer
//                 </Button>
//                 <span style={{ fontWeight: "600", color: attemptOnce ? "#dc3545" : "#28a745", fontSize: '14px' }}>
//                   🔒 Ce quiz est {attemptOnce ? "limité à une seule tentative" : "rejouable"}.
//                 </span>
//               </div>
//             </div>

//             {/* PROGRESSION */}
//             <Card
//               title={<span style={{ fontSize: "18px", fontWeight: "bold", color: "#1890ff" }}><FileTextOutlined /> Résultats et progression</span>}
//               style={{ borderRadius: "16px", boxShadow: "0 4px 20px rgba(0, 0, 0, 0.08)", border: '1px solid #e9ecef' }}
//             >
//               {progress && progress.length > 0 ? (
//                 <List
//                   itemLayout="horizontal"
//                   dataSource={progress}
//                   renderItem={(item) => {
//                     const pct = item.pct ?? 0;
//                     const icon = pct >= 80 ? <CheckCircleTwoTone twoToneColor="#52c41a" /> : pct >= 50 ? <InfoCircleTwoTone twoToneColor="#faad14" /> : <CloseCircleTwoTone twoToneColor="#ff4d4f" />;
//                     const color = pct >= 80 ? "green" : pct >= 50 ? "orange" : "red";

//                     return (
//                       <List.Item style={{ backgroundColor: "#fafafa", marginBottom: "20px", padding: "20px", borderRadius: "12px", boxShadow: "0 2px 8px rgba(0,0,0,0.06)", border: '1px solid #f0f0f0' }}>
//                         <List.Item.Meta
//                           avatar={icon}
//                           title={<span style={{ fontWeight: "bold", color: "#333", fontSize: '16px' }}>Quiz N° : {item.quizId ?? "N/A"}</span>}
//                           description={
//                             <>
//                               <Progress percent={pct} status={pct >= 80 ? "success" : pct >= 50 ? "active" : "exception"} strokeColor={color} style={{ marginBottom: '12px' }} />
//                               <Tag color={color} style={{ fontSize: '13px', padding: '4px 8px' }}>{item.scoreObtained ?? 0}/{item.scoreTotal ?? 0} points</Tag>
//                             </>
//                           }
//                         />
//                       </List.Item>
//                     );
//                   }}
//                 />
//               ) : (
//                 <div style={{ textAlign: "center", color: "#999", padding: '50px' }}>
//                   <FileTextOutlined style={{ fontSize: '48px', marginBottom: '16px' }} />
//                   <p>Aucune donnée de progression trouvée.</p>
//                 </div>
//               )}
//             </Card>
//           </div>
//         )}

//         {renderQuizSummaryModal()}
//       </div>
//     </div>
//   );
// };

// export default TestDeConnaissance;


import React, { useEffect, useState } from "react";
import { Card, Checkbox, Radio, Divider, Badge, Tooltip, Spin, Alert, Steps, Button, Modal, List, Tag, Progress } from "antd";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import courseService from "../../services/course.service";
import MatchingQuestionViewer from "./MatchingQuestionViewer";
import { CheckCircleTwoTone, FileTextOutlined, InfoCircleTwoTone, CloseCircleTwoTone, ClockCircleOutlined, TrophyOutlined, BookOutlined } from '@ant-design/icons';
import { useDispatch } from "react-redux";
import { recalculateNote } from "../../actions/noteActions";
import DragDropZones from '../moderateur/quizes/DragDropZones';
import DragDropImage from '../moderateur/quizes/drag_drop_images/DragDropImage';


const { Step } = Steps;

const TestDeConnaissance = ({ quizId, courseId, attemptOnce = false }) => {
  const dispatch = useDispatch();

  // ✅ TOUS LES STATES
  const [quiz, setQuiz] = useState(null);
  const [showIntroduction, setShowIntroduction] = useState(true);
  const [questions, setQuestions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [userAnswers, setUserAnswers] = useState({});
  const [submitted, setSubmitted] = useState(false);
  const [currentStep, setCurrentStep] = useState(0);
  const [threshold, setThreshold] = useState(0);
  const [isGeneratingBadge, setIsGeneratingBadge] = useState(false);
  const [downloading, setDownloading] = useState(false);
  const [reviewResults, setReviewResults] = useState([]);
  const [showSummaryModal, setShowSummaryModal] = useState(false);
  const [score, setScore] = useState(0);
  const [myscore_stored, setmyscore_stored] = useState(0);
  const [resultSaved, setResultSaved] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [progress, setProgress] = useState([]);
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const questionsLoadedRef = React.useRef(false); // ✅ Empêche le double chargement/re-shuffle

  // ✅ VARIABLES CALCULÉES
  const totalPossibleScore = questions.reduce((sum, q) => sum + (q.score || 0), 0);
  const isAttemptOnce = attemptOnce === true || attemptOnce === 1;
  const storedUser = JSON.parse(localStorage.getItem("user"));
  const userId = storedUser?.id || null;

  // ✅ FONCTIONS UTILITAIRES
  const shuffleArray = (array) => {
    const shuffled = [...array];
    for (let i = shuffled.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
    }
    return shuffled;
  };

  const isValidHtml = (html) => {
    const div = document.createElement("div");
    div.innerHTML = html;
    return div.textContent.trim().length > 0;
  };

  const calculateScore = () => {
    if (!submitted) return 0;
    return questions.reduce((sum, q) => isCorrect(q) ? sum + (q.score || 0) : sum, 0);
  };

  // ✅ CORRECTION 3 : isCorrect avec cas DRAG_DROP séparé (comparaison position par position)
  const isCorrect = (question) => {
    const userAnswer = userAnswers[question.id];

    if (question.questionType === "MATCHING") {
      if (!userAnswer) return false;
      return question.options.every(
        (pair) => userAnswer[pair.leftText] === pair.rightText
      );
    }

    if (question.questionType === "DRAG_DROP_IMAGE") {
      if (!userAnswer || typeof userAnswer !== 'object') return false;
      const zones = question.imageZones || [];
      return zones.every((zone) => {
        return userAnswer[zone.id.toString()] === zone.correctAnswer;
      });
    }

    if (question.questionType === "DRAG_DROP_ZONES") {
      if (!userAnswer || typeof userAnswer !== 'object') return false;
      const zones = question.zones || [];
      return zones.every((zone) => {
        return userAnswer[zone.id.toString()] === zone.correctAnswer;
      });
    }

    // ✅ DRAG_DROP : comparer position par position (l'ordre compte !)
    if (question.questionType === "DRAG_DROP") {
      if (!Array.isArray(userAnswer)) return false;
      const correctOrder = question.correctAnswers || [];
      if (userAnswer.length !== correctOrder.length) return false;
      return userAnswer.every((text, index) => text === correctOrder[index]);
    }

    const correct = question.correctAnswers;
    if (Array.isArray(userAnswer)) {
      return JSON.stringify(userAnswer.sort()) === JSON.stringify(correct.sort());
    }
    return userAnswer === correct[0];
  };

  const handleStartQuiz = () => {
    console.log("🚀 Démarrage du quiz - Masquage de l'introduction");
    setShowIntroduction(false);
  };

  // ✅ Charger les infos du quiz
  useEffect(() => {
    const loadQuizInfo = async () => {
      try {
        console.log("📋 Chargement des infos du quiz ID:", quizId);
        const quizData = await courseService.getQuizByIdWithIntro(quizId);
        console.log("✅ Quiz chargé:", quizData);
        setQuiz(quizData);
        await checkExistingSubmission();
      } catch (error) {
        console.error("❌ Erreur lors du chargement du quiz :", error);
        setError("Erreur lors du chargement du quiz.");
      }
    };

    if (quizId) {
      loadQuizInfo();
    }
  }, [quizId]);

  // ✅ CORRECTION 1 : Charger les questions — DRAG_DROP correctAnswers = ordre backend (orderIndex)
  // ✅ FIX : Ne pas recharger si les questions sont déjà chargées (évite re-shuffle)
  useEffect(() => {
    const loadQuiz = async () => {
      if (!quiz) return;
      if (questionsLoadedRef.current) {
        console.log("⏭️ Questions déjà chargées, skip reload (évite re-shuffle)");
        return;
      }
      questionsLoadedRef.current = true;

      try {
        console.log("📝 Chargement optimisé des questions du quiz:", quizId);
        const questionList = await courseService.getQuestionsWithAnswers(quizId);

        const questionsWithOptions = questionList.map((question) => {
          if (question.questionType === "MATCHING") {
            return { ...question, options: question.matchingPairs || [] };
          }
          else if (question.questionType === "DRAG_DROP_ZONES") {
            return {
              ...question,
              zones: question.zones || [],
              propositions: question.propositions || []
            };
          }
          else if (question.questionType === "DRAG_DROP_IMAGE") {
            return {
              ...question,
              imageZones: question.imageZones || [],
              propositions: question.propositions || []
            };
          }
          // ✅ CORRECTION DRAG_DROP : l'ordre correct = ordre du backend (trié par orderIndex)
          else if (question.questionType === "DRAG_DROP") {
            const options = question.answers || [];
            // L'ordre correct = l'ordre venant du backend (déjà trié par orderIndex)
            const correctOrder = options.map(opt => opt.text);
            // Mélanger pour l'affichage étudiant
            const shuffledOptions = shuffleArray(options);
            return { ...question, options: shuffledOptions, correctAnswers: correctOrder };
          }
          else {
            const options = question.answers || [];
            const correctAnswers = options.filter(opt => opt.isCorrect || opt.correct).map(opt => opt.text);
            return { ...question, options, correctAnswers };
          }
        });

        setQuestions(questionsWithOptions);
        console.log("✅ Questions traitées (optimisé):", questionsWithOptions.length);
      } catch (err) {
        console.error("Erreur chargement quiz:", err);
        setError("Erreur lors du chargement du quiz.");
      } finally {
        setLoading(false);
      }
    };

    loadQuiz();
  }, [quiz, quizId, refreshTrigger]);

  // 3️⃣ Lazy load des images
  useEffect(() => {
    const loadImageIfNeeded = async () => {
      if (!questions.length) return;
      const currentQ = questions[currentStep];

      if (currentQ?.questionType === "DRAG_DROP_IMAGE" && !currentQ.imageLoaded) {
        try {
          console.log("🖼️ Lazy loading images pour question:", currentQ.id);
          const imageData = await courseService.getQuestionImageData(currentQ.id);

          setQuestions(prev => prev.map((q, idx) =>
            idx === currentStep
              ? { ...q, imageZones: imageData.imageZones, propositions: imageData.propositions, imageUrl: imageData.imageUrl, imageLoaded: true }
              : q
          ));
          console.log("✅ Images chargées pour question:", currentQ.id);
        } catch (err) {
          console.error("❌ Erreur chargement images:", err);
        }
      }
    };
    loadImageIfNeeded();
  }, [currentStep, questions.length]);

  const checkExistingSubmission = async () => {
    try {
      const user = JSON.parse(localStorage.getItem("user"));
      console.log("🔍 Vérification soumission existante pour userId:", user.id, "quizId:", quizId);

      const review = await courseService.getQuizReviewResults(user.id, quizId);
      console.log("📦 Review reçue:", review);

      if (review && review.length > 0) {
        console.log("⚠️ Quiz déjà soumis - Passage direct aux résultats");
        const reconstructedAnswers = {};

        review.forEach((question) => {
          const type = question.questionType;
          console.log(`📝 Reconstruction pour question ${question.questionId} - Type: ${type}`);

          if (type === "QCU" || type === "VRAI_FAUX") {
            reconstructedAnswers[question.questionId] = question.userAnswers[0]?.text || "";
          }
          else if (type === "QCM") {
            reconstructedAnswers[question.questionId] = question.userAnswers.map(a => a.text);
          }
          else if (type === "MATCHING") {
            const map = {};
            question.userAnswers.forEach((a) => {
              map[a.leftText] = a.rightText;
            });
            reconstructedAnswers[question.questionId] = map;
          }
          else if (type === "DRAG_DROP_IMAGE") {
            const imageZoneAnswers = {};

            if (question.imageZoneAnswers && Array.isArray(question.imageZoneAnswers)) {
              console.log(`   🖼️ ${question.imageZoneAnswers.length} zones image trouvées`);
              question.imageZoneAnswers.forEach((zone) => {
                const zoneId = zone.imageZoneId;
                const userAnswer = zone.userAnswer;

                if (zoneId !== null && zoneId !== undefined) {
                  imageZoneAnswers[zoneId.toString()] = userAnswer;
                  console.log(`   ✅ Zone image ${zoneId}: ${userAnswer}`);
                }
              });
            }

            reconstructedAnswers[question.questionId] = imageZoneAnswers;
            console.log(`   ✅ Réponses image reconstruites:`, imageZoneAnswers);
          }
          else if (type === "DRAG_DROP_ZONES") {
            const zoneAnswers = {};

            if (question.zoneAnswers && Array.isArray(question.zoneAnswers)) {
              console.log(`   🎯 ${question.zoneAnswers.length} zones trouvées`);
              question.zoneAnswers.forEach((zone) => {
                if (zone.zoneId !== null && zone.zoneId !== undefined) {
                  zoneAnswers[zone.zoneId.toString()] = zone.userAnswer;
                  console.log(`   Zone ${zone.zoneId}: ${zone.userAnswer}`);
                }
              });
            }

            reconstructedAnswers[question.questionId] = zoneAnswers;
            console.log(`   ✅ Réponses reconstruites:`, zoneAnswers);
          }
          // ✅ DRAG_DROP : reconstruire l'ordre de l'utilisateur
          else if (type === "DRAG_DROP") {
            if (question.userAnswers && Array.isArray(question.userAnswers)) {
              console.log(`   📋 ${question.userAnswers.length} réponses DRAG_DROP trouvées`);
              const orderedAnswers = question.userAnswers.map(answer => answer.text);
              reconstructedAnswers[question.questionId] = orderedAnswers;
              console.log(`   ✅ Réponses DRAG_DROP reconstruites:`, orderedAnswers);
            } else {
              console.error(`   ❌ userAnswers manquant pour DRAG_DROP`);
              reconstructedAnswers[question.questionId] = [];
            }
          }
        });

        console.log("📊 Toutes les réponses reconstruites:", reconstructedAnswers);

        setUserAnswers(reconstructedAnswers);
        setSubmitted(true);
        setResultSaved(true);
        setShowIntroduction(false);

        console.log("✅ États mis à jour - showIntroduction=false, submitted=true");
      } else {
        console.log("ℹ️ Review vide - Aucune soumission existante");
      }
    } catch (error) {
      console.error("❌ Erreur dans checkExistingSubmission:", error);
      if (error.response?.status !== 404) {
        console.error("Response:", error.response?.data);
      }
    }
  };

  useEffect(() => {
    const loadThreshold = async () => {
      try {
        if (!courseId) return;
        const fetchedThreshold = await courseService.getThreshold(courseId);
        console.log("🎯 Seuil récupéré du backend :", fetchedThreshold);
        setThreshold(fetchedThreshold);
      } catch (err) {
        console.error("Erreur lors de la récupération du seuil :", err);
      }
    };
    loadThreshold();
  }, [courseId]);

  useEffect(() => {
    const loadProgress = async () => {
      try {
        if (!courseId || !userId) return;
        const fetchedProgress = await courseService.CalculePrgresseByType(
          "controle", courseId, userId, quizId
        );
        console.log("📊 Progression récupérée du backend :", fetchedProgress);
        setProgress(fetchedProgress);
      } catch (err) {
        console.error("❌ Erreur lors de la récupération du progrès :", err);
      }
    };
    loadProgress();
  }, [courseId, userId, quizId, refreshTrigger]);

  useEffect(() => {
    const fetchReview = async () => {
      if (!submitted || !quizId) return;

      try {
        const user = JSON.parse(localStorage.getItem("user"));
        const review = await courseService.getQuizReviewResults(user.id, quizId);

        console.log("🔁 REVIEW API - RÉPONSE COMPLÈTE");
        console.log(JSON.stringify(review, null, 2));

        review.forEach((q, index) => {
          console.log(`\n📝 Question ${index + 1}:`, {
            questionId: q.questionId,
            questionType: q.questionType,
            questionText: q.questionText,
            score: q.score
          });

          if (q.questionType === "DRAG_DROP_ZONES") {
            console.log("   🎯 zoneAnswers:", q.zoneAnswers);
          } else if (q.questionType === "DRAG_DROP") {
            console.log("   📋 userAnswers:", q.userAnswers);
            console.log("   📋 correctAnswers:", q.correctAnswers);
          }
        });

        setmyscore_stored(review[0].score);
        setReviewResults(review);
      } catch (error) {
        console.error("❌ ERREUR lors du chargement de la review:", error.message);
      }
    };

    fetchReview();
  }, [submitted, quizId]);

  const buildAnswersPayload = () => {
    const answersArray = [];

    console.log("\n🔨 CONSTRUCTION DU PAYLOAD");

    questions.forEach((question, qIndex) => {
      const userAnswer = userAnswers[question.id];

      console.log(`\n📝 Question ${qIndex + 1} (ID: ${question.id}) - ${question.questionType}`);
      console.log(`   Réponse brute:`, userAnswer);

      // ✅ CAS 1 : Réponse simple (QCU, VRAI_FAUX)
      if (typeof userAnswer === "string") {
        const answer = question.options.find((opt) => opt.text === userAnswer);
        if (answer) {
          answersArray.push({ questionId: question.id, answerId: answer.id });
          console.log(`   ✅ Ajouté: answerId=${answer.id}`);
        }
      }

      // ✅ CAS 2 : DRAG_DROP (ordre important) - DOIT ÊTRE AVANT le cas Array générique
      else if (question.questionType === "DRAG_DROP" && Array.isArray(userAnswer)) {
        console.log(`   📋 Type DRAG_DROP détecté - Ordre: ${userAnswer.length} éléments`);
        userAnswer.forEach((answerText, orderIndex) => {
          const answer = question.options.find((opt) => opt.text === answerText);
          if (answer) {
            answersArray.push({ questionId: question.id, answerId: answer.id });
            console.log(`   ✅ Position ${orderIndex + 1}: answerId=${answer.id} ("${answerText}")`);
          }
        });
      }

      // ✅ CAS 3 : QCM (ordre pas important)
      else if (Array.isArray(userAnswer)) {
        userAnswer.forEach((answerText) => {
          const answer = question.options.find((opt) => opt.text === answerText);
          if (answer) {
            answersArray.push({ questionId: question.id, answerId: answer.id });
          }
        });
      }

      // ✅ CAS 4 : DRAG_DROP_IMAGE
      else if (question.questionType === "DRAG_DROP_IMAGE" && typeof userAnswer === "object") {
        const zones = question.imageZones || [];
        const propositions = question.propositions || [];

        Object.entries(userAnswer).forEach(([zoneId, content]) => {
          const proposition = propositions.find(p =>
            p.propositionContent === content || p.content === content || p.text === content
          );
          const zone = zones.find(z => z.id.toString() === zoneId);

          if (proposition && zone) {
            answersArray.push({
              questionId: question.id,
              imageZoneId: zone.id,
              propositionId: proposition.id,
            });
          }
        });
      }

      // ✅ CAS 5 : DRAG_DROP_ZONES
      else if (question.questionType === "DRAG_DROP_ZONES" && typeof userAnswer === "object") {
        const zones = question.zones || [];
        const propositions = question.propositions || [];

        Object.entries(userAnswer).forEach(([zoneId, content]) => {
          const proposition = propositions.find(p =>
            p.propositionContent === content || p.content === content || p.text === content
          );
          const zone = zones.find(z => z.id.toString() === zoneId);

          if (proposition && zone) {
            answersArray.push({
              questionId: question.id,
              zoneId: zone.id,
              propositionId: proposition.id,
            });
          }
        });
      }

      // ✅ CAS 6 : MATCHING
      else if (question.questionType === "MATCHING" && typeof userAnswer === "object") {
        const pairs = question.options || [];
        pairs.forEach((pair) => {
          const selected = userAnswer[pair.leftText];
          const answer = question.options.find(
            (opt) => opt.leftText === pair.leftText && opt.rightText === selected
          );
          if (answer && answer.id) {
            answersArray.push({ questionId: question.id, answerId: answer.id });
          }
        });
      }
    });

    console.log(`📦 PAYLOAD FINAL: ${answersArray.length} réponses`);
    return answersArray;
  };

  const handleSubmit = async () => {
    setSubmitting(true);

    const scoreNow = questions.reduce(
      (sum, q) => (isCorrect(q) ? sum + (q.score || 0) : sum), 0
    );
    setScore(scoreNow);

    try {
      const user = JSON.parse(localStorage.getItem("user"));
      const payload = buildAnswersPayload();

      console.log("🚀 Envoi de la requête au backend...");
      const response = await courseService.submitQuizResult({
        userId: user.id,
        quizId: quizId,
        scoreObtained: scoreNow,
        scoreTotal: totalPossibleScore,
        answers: payload,
      });

      console.log("✅ Résultat du quiz soumis avec succès.");
      setResultSaved(true);
      setSubmitted(true);
      setRefreshTrigger(prev => prev + 1);
      dispatch(recalculateNote(courseId, user.id));

    } catch (error) {
      console.error("❌ ERREUR LORS DE LA SOUMISSION:", error.message);
      alert("Une erreur est survenue lors de l'enregistrement du score: " +
        (error.response?.data?.message || error.message));
    } finally {
      setSubmitting(false);
    }
  };

  // ✅ CORRECTION 2 : DragDropPreview avec feedback position par position
  const DragDropPreview = ({ question }) => {
    const existingAnswer = userAnswers[question.id];

    const getInitialItems = () => {
      if (existingAnswer && Array.isArray(existingAnswer)) {
        return existingAnswer.map((text, index) => ({
          id: `option-${index}`,
          content: text,
        }));
      }
      return question.options.map((opt, index) => ({
        id: `option-${index}`,
        content: opt.text,
      }));
    };

    const [items, setItems] = useState(getInitialItems);

    const onDragEnd = (result) => {
      if (!result.destination || submitted) return;

      const reordered = Array.from(items);
      const [moved] = reordered.splice(result.source.index, 1);
      reordered.splice(result.destination.index, 0, moved);
      setItems(reordered);

      const orderedTexts = reordered.map(item => item.content);
      setUserAnswers({
        ...userAnswers,
        [question.id]: orderedTexts
      });
      console.log("✅ Ordre sauvegardé:", orderedTexts);
    };

    // Déterminer si chaque position est correcte
    const getPositionStatus = (index) => {
      if (!submitted) return null;
      const userAnswer = userAnswers[question.id] || [];
      const correctOrder = question.correctAnswers || [];
      if (index >= userAnswer.length || index >= correctOrder.length) return null;
      return userAnswer[index] === correctOrder[index];
    };

    return (
      <div style={{ backgroundColor: "#f1f8e9", padding: "16px", borderRadius: "10px" }}>
        <DragDropContext onDragEnd={onDragEnd}>
          <Droppable droppableId="droppable-options">
            {(provided) => (
              <ul
                {...provided.droppableProps}
                ref={provided.innerRef}
                style={{ listStyleType: "none", paddingLeft: 0 }}
              >
                {items.map((item, index) => {
                  const positionCorrect = getPositionStatus(index);
                  let backgroundColor = "#e8f5e9";
                  if (submitted && positionCorrect !== null) {
                    backgroundColor = positionCorrect ? "#c8e6c9" : "#ffcdd2";
                  }

                  return (
                    <Draggable
                      key={item.id}
                      draggableId={item.id}
                      index={index}
                      isDragDisabled={submitted}
                    >
                      {(provided, snapshot) => (
                        <li
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          {...provided.dragHandleProps}
                          style={{
                            padding: "12px 16px",
                            marginBottom: "8px",
                            backgroundColor: snapshot.isDragging ? "#c8e6c9" : backgroundColor,
                            border: snapshot.isDragging
                              ? "2px solid #66bb6a"
                              : submitted
                                ? `1px solid ${positionCorrect ? '#4caf50' : '#f44336'}`
                                : "1px solid #e0e0e0",
                            borderRadius: "8px",
                            cursor: submitted ? "default" : "grab",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            transition: "all 0.2s ease",
                            ...provided.draggableProps.style,
                          }}
                        >
                          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                            <Badge
                              count={index + 1}
                              style={{
                                backgroundColor: submitted
                                  ? (positionCorrect ? '#52c41a' : '#ff4d4f')
                                  : '#1890ff',
                                fontSize: '12px'
                              }}
                            />
                            <span style={{ fontSize: "15px" }}>{item.content}</span>
                          </div>

                          {submitted && positionCorrect !== null && (
                            <span style={{ fontSize: "18px" }}>
                              {positionCorrect ? "✅" : "❌"}
                            </span>
                          )}
                        </li>
                      )}
                    </Draggable>
                  );
                })}
                {provided.placeholder}
              </ul>
            )}
          </Droppable>
        </DragDropContext>

        {/* Afficher l'ordre correct après soumission si des erreurs */}
        {submitted && question.correctAnswers && (() => {
          const userAnswer = userAnswers[question.id] || [];
          const hasErrors = question.correctAnswers.some((ans, i) => ans !== userAnswer[i]);
          if (!hasErrors) return null;
          return (
            <div style={{
              marginTop: "16px",
              padding: "12px",
              background: "#fff3cd",
              borderRadius: "8px",
              border: "1px solid #ffc107"
            }}>
              <strong style={{ color: "#856404" }}>📋 Ordre correct :</strong>
              <ol style={{ marginTop: "8px", marginBottom: 0, paddingLeft: "20px" }}>
                {question.correctAnswers.map((answer, idx) => (
                  <li key={idx} style={{ color: "#856404", marginBottom: "4px" }}>
                    {answer}
                  </li>
                ))}
              </ol>
            </div>
          );
        })()}
      </div>
    );
  };


  const renderQuestion = (question) => {
    const userAnswer = userAnswers[question.id];

    if (question.questionType === "QCU" || question.questionType === "VRAI_FAUX") {
      return (
        <div style={{
          display: question.imageUrl ? 'grid' : 'block',
          gridTemplateColumns: question.imageUrl ? '1fr 1fr' : '1fr',
          gap: '20px',
          alignItems: 'start'
        }}>
          <Radio.Group
            value={userAnswer}
            onChange={(e) => setUserAnswers({ ...userAnswers, [question.id]: e.target.value })}
            disabled={submitted}
            style={{ display: "flex", flexDirection: "column", gap: "12px" }}
          >
            {(question.options || []).map((option, i) => {
              const isSelected = userAnswer === option.text;
              const isCorrectAnswer = question.correctAnswers?.includes(option.text);
              const showFeedback = submitted;

              let backgroundColor = "transparent";
              if (showFeedback) {
                if (isCorrectAnswer) backgroundColor = "#e8f5e9";
                else if (isSelected && !isCorrectAnswer) backgroundColor = "#ffebee";
              }

              return (
                <Radio
                  key={i}
                  value={option.text}
                  style={{
                    backgroundColor,
                    borderRadius: "8px",
                    padding: "12px 16px",
                    display: "flex",
                    alignItems: "center",
                    border: "1px solid #e0e0e0",
                    transition: "all 0.2s ease"
                  }}
                >
                  <span style={{ fontSize: "15px" }}>{option.text}</span>
                  {showFeedback && isCorrectAnswer && (
                    <span style={{ marginLeft: "12px", color: "green", fontSize: "18px" }}>✅</span>
                  )}
                  {showFeedback && isSelected && !isCorrectAnswer && (
                    <span style={{ marginLeft: "12px", color: "red", fontSize: "18px" }}>❌</span>
                  )}
                </Radio>
              );
            })}
          </Radio.Group>

          {question.imageUrl && (
            <div style={{
              borderRadius: '12px',
              overflow: 'hidden',
              border: '2px solid #e9ecef',
              background: '#fafafa',
              position: 'relative',
              boxShadow: '0 4px 15px rgba(0, 0, 0, 0.08)'
            }}>
              <div style={{
                position: 'absolute', top: '10px', left: '10px',
                background: 'rgba(0, 0, 0, 0.6)', color: 'white',
                padding: '4px 10px', borderRadius: '6px', fontSize: '11px',
                fontWeight: '500', zIndex: 1, backdropFilter: 'blur(4px)'
              }}>
                🖼️ Illustration
              </div>
              <img
                src={question.imageUrl}
                alt="Illustration de la question"
                style={{ width: '100%', display: 'block', objectFit: 'contain', maxHeight: '400px' }}
              />
            </div>
          )}
        </div>
      );
    }

    if (question.questionType === "QCM") {
      const selectedAnswers = userAnswer || [];
      return (
        <div style={{
          display: question.imageUrl ? 'grid' : 'block',
          gridTemplateColumns: question.imageUrl ? '1fr 1fr' : '1fr',
          gap: '20px',
          alignItems: 'start'
        }}>
          <Checkbox.Group
            value={selectedAnswers}
            onChange={(values) => setUserAnswers({ ...userAnswers, [question.id]: values })}
            disabled={submitted}
            style={{ display: "flex", flexDirection: "column", gap: "12px" }}
          >
            {(question.options || []).map((option, i) => {
              const isSelected = selectedAnswers.includes(option.text);
              const isCorrectAnswer = question.correctAnswers?.includes(option.text);
              const showFeedback = submitted;

              let backgroundColor = "transparent";
              if (showFeedback) {
                if (isCorrectAnswer) backgroundColor = "#e8f5e9";
                else if (isSelected && !isCorrectAnswer) backgroundColor = "#ffebee";
              }

              return (
                <Checkbox
                  key={i}
                  value={option.text}
                  style={{
                    backgroundColor,
                    borderRadius: "8px",
                    padding: "12px 16px",
                    display: "flex",
                    alignItems: "center",
                    border: "1px solid #e0e0e0",
                    transition: "all 0.2s ease"
                  }}
                >
                  <span style={{ fontSize: "15px" }}>{option.text}</span>
                  {showFeedback && isCorrectAnswer && (
                    <span style={{ marginLeft: "12px", color: "green", fontSize: "18px" }}>✅</span>
                  )}
                  {showFeedback && isSelected && !isCorrectAnswer && (
                    <span style={{ marginLeft: "12px", color: "red", fontSize: "18px" }}>❌</span>
                  )}
                </Checkbox>
              );
            })}
          </Checkbox.Group>

          {question.imageUrl && (
            <div style={{
              borderRadius: '12px', overflow: 'hidden',
              border: '2px solid #e9ecef', background: '#fafafa',
              position: 'relative', boxShadow: '0 4px 15px rgba(0, 0, 0, 0.08)'
            }}>
              <div style={{
                position: 'absolute', top: '10px', left: '10px',
                background: 'rgba(0, 0, 0, 0.6)', color: 'white',
                padding: '4px 10px', borderRadius: '6px', fontSize: '11px',
                fontWeight: '500', zIndex: 1, backdropFilter: 'blur(4px)'
              }}>
                🖼️ Illustration
              </div>
              <img
                src={question.imageUrl}
                alt="Illustration de la question"
                style={{ width: '100%', display: 'block', objectFit: 'contain', maxHeight: '400px' }}
              />
            </div>
          )}
        </div>
      );
    }

    if (question.questionType === "DRAG_DROP") {
      return <DragDropPreview key={`dragdrop-${question.id}`} question={question} />;
    }

    if (question.questionType === "DRAG_DROP_IMAGE") {
      const zones = (question.imageZones || []).map(zone => ({
        id: zone.id, label: zone.zoneLabel, correctAnswer: zone.correctAnswer,
        x: zone.posX, y: zone.posY, width: zone.width, height: zone.height
      }));

      const propositions = (question.propositions || []).map(prop => ({
        id: prop.id, content: prop.propositionContent || prop.content || prop.text
      }));

      const handleAnswerChange = (answer) => {
        const isZoneMapping = typeof answer === 'object' && !answer.zoneId && !answer.content;

        if (isZoneMapping) {
          const newAnswers = { ...(userAnswer || {}), ...answer };
          setUserAnswers({ ...userAnswers, [question.id]: newAnswers });
          return;
        }

        const newAnswers = { ...(userAnswer || {}), [answer.zoneId]: answer.content };
        setUserAnswers({ ...userAnswers, [question.id]: newAnswers });
      };

      return (
        <DragDropImage
          imageUrl={question.imageUrl}
          dropZones={zones}
          propositions={propositions}
          onAnswerChange={handleAnswerChange}
          showCorrectAnswers={submitted}
          initialFilledZones={userAnswer || {}}
        />
      );
    }

    if (question.questionType === "MATCHING") {
      return (
        <MatchingQuestionViewer
          key={submitted + JSON.stringify(userAnswers[question.id] || {})}
          pairs={question.options || []}
          questionId={question.id}
          userAnswers={userAnswers}
          setUserAnswers={setUserAnswers}
          disabled={submitted}
        />
      );
    }

    if (question.questionType === "DRAG_DROP_ZONES") {
      const zones = (question.zones || []).map(zone => ({
        id: zone.id.toString(), label: zone.zoneLabel || zone.label, correctAnswer: zone.correctAnswer
      }));

      const propositions = (question.propositions || []).map(prop => ({
        id: prop.id.toString(), content: prop.propositionContent || prop.content || prop.text
      }));

      const handleAnswerChange = (answer) => {
        if (typeof answer === 'object' && !answer.zoneId) {
          setUserAnswers({ ...userAnswers, [question.id]: answer });
          return;
        }

        const newAnswers = { ...(userAnswer || {}), [answer.zoneId]: answer.content };
        setUserAnswers({ ...userAnswers, [question.id]: newAnswers });
      };

      return (
        <DragDropZones
          zones={zones}
          propositions={propositions}
          onAnswerChange={handleAnswerChange}
          showCorrectAnswers={false}
          initialFilledZones={userAnswer || {}}
        />
      );
    }

    return <p style={{ color: "red" }}>❗ Type non supporté : {question.questionType}</p>;
  };

  // ✅ FONCTION POUR RENDRE L'INTRODUCTION PROFESSIONNELLE
  const renderIntroduction = () => (
    <div
      style={{
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        padding: '20px', fontFamily: "'Segoe UI', 'Roboto', sans-serif"
      }}
    >
      <div style={{
        background: '#ffffff', borderRadius: '16px', padding: '0',
        maxWidth: '1200px', width: '100%',
        boxShadow: '0 20px 60px rgba(0, 0, 0, 0.1)', overflow: 'hidden'
      }}>
        {/* HEADER */}
        <div style={{
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          color: 'white', padding: '30px 40px',
          display: 'flex', justifyContent: 'space-between', alignItems: 'center'
        }}>
          <div>
            <div style={{ fontSize: '12px', textTransform: 'uppercase', letterSpacing: '1px', opacity: '0.9', marginBottom: '8px' }}>
              {quiz?.linkType === 'evaluation' ? 'ÉVALUATION' : 'CONTRÔLE DE CONNAISSANCES'}
            </div>
            <h1 style={{ fontSize: '28px', fontWeight: '700', margin: '0', lineHeight: '1.2' }}>
              {quiz?.title || 'Test de connaissances'}
            </h1>
          </div>
          <div style={{ textAlign: 'right', fontSize: '14px', opacity: '0.9' }}>
            <div>{quiz?.course?.title || 'Cours en ligne'}</div>
          </div>
        </div>

        {/* CONTENU */}
        <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr', gap: '0' }}>
          <div style={{ padding: '40px' }}>
            <h2 style={{ fontSize: '20px', fontWeight: '600', color: '#2c3e50', marginBottom: '20px', borderBottom: '2px solid #e9ecef', paddingBottom: '10px' }}>
              📋 Présentation du contrôle
            </h2>

            {quiz?.introductionText && quiz.introductionText.trim() !== '' ? (
              <div
                style={{ fontSize: '15px', lineHeight: '1.7', color: '#495057', background: '#f8f9fa', padding: '25px', borderRadius: '12px', border: '1px solid #e9ecef' }}
                dangerouslySetInnerHTML={{ __html: quiz.introductionText }}
              />
            ) : (
              <div style={{ fontSize: '15px', lineHeight: '1.7', color: '#6c757d', fontStyle: 'italic' }}>
                Ce contrôle évalue vos connaissances sur les sujets abordés dans le cours.
              </div>
            )}

            <div style={{ marginTop: '30px' }}>
              <h3 style={{ fontSize: '16px', fontWeight: '600', color: '#2c3e50', marginBottom: '15px' }}>🎯 Instructions</h3>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px', fontSize: '14px', color: '#495057' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}><span>📖</span><span>Lisez chaque question attentivement</span></div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}><span>🤔</span><span>Réfléchissez avant de répondre</span></div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}><span>⏰</span><span>Gérez votre temps efficacement</span></div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}><span>✅</span><span>Vérifiez vos réponses</span></div>
              </div>
            </div>
          </div>

          <div style={{ background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)', padding: '40px 30px', borderLeft: '1px solid #e9ecef' }}>
            <div style={{ background: 'white', borderRadius: '12px', padding: '25px', marginBottom: '25px', boxShadow: '0 4px 15px rgba(0, 0, 0, 0.05)' }}>
              <h3 style={{ fontSize: '16px', fontWeight: '600', color: '#2c3e50', marginBottom: '20px', textAlign: 'center' }}>📊 Informations</h3>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px 15px', background: '#f8f9fa', borderRadius: '8px' }}>
                  <span style={{ color: '#6c757d', fontSize: '14px' }}><BookOutlined style={{ marginRight: '8px', color: '#1976d2' }} />Questions</span>
                  <strong style={{ color: '#1976d2', fontSize: '16px' }}>{questions.length}</strong>
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px 15px', background: '#f8f9fa', borderRadius: '8px' }}>
                  <span style={{ color: '#6c757d', fontSize: '14px' }}><TrophyOutlined style={{ marginRight: '8px', color: '#388e3c' }} />Points</span>
                  <strong style={{ color: '#388e3c', fontSize: '16px' }}>{totalPossibleScore}</strong>
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px 15px', background: '#f8f9fa', borderRadius: '8px' }}>
                  <span style={{ color: '#6c757d', fontSize: '14px' }}><ClockCircleOutlined style={{ marginRight: '8px', color: '#f57c00' }} />Durée estimée</span>
                  <strong style={{ color: '#f57c00', fontSize: '16px' }}>~{Math.ceil(questions.length * 1.5)} min</strong>
                </div>
              </div>
            </div>

            <div style={{
              background: quiz?.attemptOnce ? '#fff3cd' : '#d1ecf1',
              border: `1px solid ${quiz?.attemptOnce ? '#ffeaa7' : '#bee5eb'}`,
              borderRadius: '12px', padding: '20px', textAlign: 'center'
            }}>
              <div style={{ fontSize: '14px', fontWeight: '600', color: quiz?.attemptOnce ? '#856404' : '#0c5460', marginBottom: '8px' }}>
                {quiz?.attemptOnce ? '⚠️ TENTATIVE UNIQUE' : '✅ TENTATIVES MULTIPLES'}
              </div>
              <div style={{ fontSize: '13px', color: quiz?.attemptOnce ? '#856404' : '#0c5460', lineHeight: '1.4' }}>
                {quiz?.attemptOnce
                  ? 'Vous n\'aurez qu\'une seule chance. Assurez-vous d\'être prêt !'
                  : 'Vous pouvez refaire ce quiz autant de fois que nécessaire.'}
              </div>
            </div>

            <Button
              type="primary" size="large" onClick={handleStartQuiz}
              style={{
                width: '100%', height: '50px', marginTop: '25px', fontSize: '16px', fontWeight: '600',
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                border: 'none', borderRadius: '12px', boxShadow: '0 4px 15px rgba(102, 126, 234, 0.4)'
              }}
            >
              🚀 Commencer le contrôle
            </Button>
          </div>
        </div>
      </div>
    </div>
  );

  const renderQuizSummaryModal = () => (
    <Modal
      title={
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <FileTextOutlined style={{ color: "#1890ff", fontSize: 20 }} />
          <span style={{ fontSize: "18px", fontWeight: 600 }}>Résumé de vos réponses</span>
        </div>
      }
      open={showSummaryModal}
      onCancel={() => setShowSummaryModal(false)}
      onOk={async () => { setShowSummaryModal(false); await handleSubmit(); }}
      okText="✅ Confirmer l'envoi"
      cancelText="✖️ Modifier mes réponses"
      okButtonProps={{ type: "primary" }}
      width={650}
    >
      <Divider style={{ margin: "10px 0 20px 0" }} />
      <List
        dataSource={questions}
        renderItem={(question, index) => {
          const userAnswer = userAnswers[question.id];
          const userText = Array.isArray(userAnswer)
            ? userAnswer.join(", ")
            : typeof userAnswer === "object"
              ? "[Réponse structurée]"
              : userAnswer || "Non répondu";

          return (
            <List.Item
              style={{
                backgroundColor: "#f9f9f9", borderLeft: "6px solid #1890ff",
                padding: "14px 18px", borderRadius: "10px", marginBottom: 10,
                transition: "transform 0.2s ease",
              }}
              onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.01)")}
              onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
            >
              <List.Item.Meta
                title={
                  <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                    <Badge count={`Q${index + 1}`} style={{ backgroundColor: "#1890ff", fontWeight: 600 }} />
                    <span style={{ fontWeight: 500 }}>{question.text}</span>
                  </div>
                }
                description={<div style={{ marginTop: 4 }}><strong>Votre réponse :</strong> {userText}</div>}
              />
            </List.Item>
          );
        }}
      />
      <Divider />
      <div style={{ textAlign: "center", color: "#888", fontSize: 13 }}>
        <InfoCircleTwoTone twoToneColor="#1890ff" /> Vérifiez vos réponses avant l'envoi définitif.
      </div>
    </Modal>
  );

  // ✅ CONDITIONS DE RETOUR
  if (loading) {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)' }}>
        <div style={{ background: 'white', padding: '40px', borderRadius: '20px', textAlign: 'center', boxShadow: '0 20px 60px rgba(0, 0, 0, 0.15)' }}>
          <Spin size="large" />
          <p style={{ marginTop: '20px', fontSize: '16px', color: '#666' }}>Chargement du quiz...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)', padding: '20px' }}>
        <Alert message="Erreur" description={error} type="error" showIcon style={{ maxWidth: '500px' }} />
      </div>
    );
  }

  if (showIntroduction && quiz) {
    return renderIntroduction();
  }

  if (!questions[currentStep]) {
    return (
      <div style={{
        minHeight: '100vh',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)'
      }}>
        <div style={{
          background: 'white', padding: '40px', borderRadius: '20px',
          textAlign: 'center', boxShadow: '0 20px 60px rgba(0, 0, 0, 0.1)'
        }}>
          <Spin size="large" />
          <p style={{ marginTop: '20px', fontSize: '16px', color: '#666' }}>
            Chargement des questions...
          </p>
        </div>
      </div>
    );
  }

  // ✅ RENDU PRINCIPAL
  return (
    <div style={{ minHeight: '100vh', background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)', padding: '20px' }}>
      <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
        {/* HEADER */}
        <div style={{
          background: 'white', borderRadius: '16px', padding: '25px 30px',
          marginBottom: '25px', boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)', border: '1px solid #e9ecef'
        }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
            <div>
              <div style={{ fontSize: '12px', textTransform: 'uppercase', letterSpacing: '1px', color: '#6c757d', marginBottom: '5px' }}>
                {quiz?.linkType === 'evaluation' ? 'ÉVALUATION' : 'CONTRÔLE DE CONNAISSANCES'}
              </div>
              <h2 style={{ margin: 0, fontSize: '24px', fontWeight: '700', color: '#2c3e50' }}>
                {quiz?.title || 'Quiz'}
              </h2>
            </div>
            {submitted && (
              <div style={{
                background: 'linear-gradient(135deg, #28a745, #20c997)', color: 'white',
                padding: '12px 20px', borderRadius: '12px', fontSize: '16px', fontWeight: '600',
                display: 'flex', alignItems: 'center', gap: '8px'
              }}>
                <TrophyOutlined /> Score : {calculateScore()} / {totalPossibleScore}
              </div>
            )}
          </div>

          <Steps current={currentStep} onChange={(step) => submitted && setCurrentStep(step)} size="small">
            {questions.map((q, index) => {
              const correct = isCorrect(q);
              const isActive = currentStep === index;
              const icon = submitted ? (
                correct ? <CheckCircleTwoTone twoToneColor="#52c41a" /> : <CloseCircleTwoTone twoToneColor="#ff4d4f" />
              ) : undefined;

              return (
                <Step key={q.id} icon={icon} title={
                  <span style={{
                    fontWeight: isActive ? "bold" : "normal",
                    color: submitted ? correct ? "#52c41a" : "#ff4d4f" : isActive ? "#1890ff" : undefined
                  }}>Q{index + 1}</span>
                } />
              );
            })}
          </Steps>
        </div>

        {/* CARTE DE QUESTION */}
        <Card
          title={
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <span style={{ fontSize: '18px', fontWeight: '600', color: '#2c3e50' }}>
                Question {currentStep + 1} : {questions[currentStep].text || "Sans titre"}
              </span>
              <Tag color="blue" style={{ fontSize: '14px', padding: '4px 12px' }}>
                {questions[currentStep].score || 0} pts
              </Tag>
            </div>
          }
          style={{ marginBottom: "25px", borderRadius: '16px', boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)', border: '1px solid #e9ecef' }}
          bodyStyle={{ padding: '30px' }}
        >
          {renderQuestion(questions[currentStep])}

          {submitted && (
            <div style={{
              marginTop: "25px", padding: "20px",
              backgroundColor: isCorrect(questions[currentStep]) ? "#e8f5e9" : "#ffebee",
              borderRadius: "12px",
              border: `2px solid ${isCorrect(questions[currentStep]) ? "#4caf50" : "#f44336"}`
            }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '12px' }}>
                <span style={{ fontSize: '22px', color: isCorrect(questions[currentStep]) ? "#2e7d32" : "#c62828" }}>
                  {isCorrect(questions[currentStep]) ? "✔️" : "❌"}
                </span>
                <strong style={{ color: isCorrect(questions[currentStep]) ? "#2e7d32" : "#c62828", fontSize: '16px' }}>
                  {isCorrect(questions[currentStep]) ? "Excellente réponse !" : "Réponse incorrecte"}
                </strong>
              </div>

              {questions[currentStep].explanation && isValidHtml(questions[currentStep].explanation) && (
                <div style={{ marginTop: "15px", padding: '15px', background: 'rgba(255, 255, 255, 0.9)', borderRadius: '8px', border: '1px solid rgba(0, 0, 0, 0.1)' }}>
                  <strong style={{ color: '#5d4037', fontSize: '15px' }}>💡 Explication :</strong>
                  <div style={{ marginTop: '8px' }}>
                    <span dangerouslySetInnerHTML={{ __html: questions[currentStep].explanation }} />
                  </div>
                </div>
              )}
            </div>
          )}
        </Card>

        {/* NAVIGATION */}
        <div style={{
          background: 'white', borderRadius: '16px', padding: '25px 30px',
          display: 'flex', justifyContent: 'space-between', alignItems: 'center',
          boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)', border: '1px solid #e9ecef'
        }}>
          <Button
            onClick={() => setCurrentStep((prev) => prev - 1)}
            disabled={currentStep === 0}
            size="large"
            style={{ minWidth: '140px', borderRadius: '8px', fontWeight: '500' }}
          >
            ← Précédent
          </Button>

          <div style={{ display: 'flex', alignItems: 'center', gap: '15px', background: '#f8f9fa', padding: '12px 20px', borderRadius: '8px' }}>
            <span style={{ color: '#6c757d', fontSize: '14px', fontWeight: '500' }}>
              Question {currentStep + 1} sur {questions.length}
            </span>
            <Progress percent={((currentStep + 1) / questions.length) * 100} showInfo={false} style={{ width: '120px' }} strokeColor="#667eea" />
          </div>

          {currentStep < questions.length - 1 ? (
            <Button
              onClick={() => setCurrentStep((prev) => prev + 1)}
              type="primary" size="large"
              style={{ minWidth: '140px', borderRadius: '8px', fontWeight: '500', background: '#667eea' }}
            >
              Suivant →
            </Button>
          ) : (
            !submitted && (
              <Button
                type="primary"
                onClick={() => setShowSummaryModal(true)}
                loading={submitting}
                disabled={submitting}
                size="large"
                style={{
                  minWidth: '180px', borderRadius: '8px', fontWeight: '600',
                  background: submitting ? "#6c757d" : 'linear-gradient(135deg, #28a745, #20c997)',
                  border: 'none'
                }}
              >
                {submitting ? "Envoi en cours..." : "🚀 Soumettre le quiz"}
              </Button>
            )
          )}
        </div>

        {/* RÉSULTATS */}
        {submitted && (
          <div style={{ marginTop: '30px' }}>
            <div style={{
              background: 'white', borderRadius: '16px', padding: '30px', textAlign: 'center',
              boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)', marginBottom: '25px', border: '1px solid #e9ecef'
            }}>
              <div style={{ marginBottom: '25px' }}>
                <Button
                  type="default"
                  disabled={attemptOnce}
                  onClick={() => {
                    if (!attemptOnce) {
                      setSubmitted(false);
                      setUserAnswers({});
                      setCurrentStep(0);
                      setQuestions([]); // ✅ Reset questions pour forcer un nouveau shuffle
                      questionsLoadedRef.current = false; // ✅ Permettre le rechargement
                      setRefreshTrigger(prev => prev + 1); // ✅ Déclencher le useEffect
                    }
                  }}
                  style={{ marginRight: '15px', borderRadius: '8px', fontWeight: '500' }}
                  size="large"
                >
                  🔄 Recommencer
                </Button>
                <span style={{ fontWeight: "600", color: attemptOnce ? "#dc3545" : "#28a745", fontSize: '14px' }}>
                  🔒 Ce quiz est {attemptOnce ? "limité à une seule tentative" : "rejouable"}.
                </span>
              </div>
            </div>

            {/* PROGRESSION */}
            <Card
              title={<span style={{ fontSize: "18px", fontWeight: "bold", color: "#1890ff" }}><FileTextOutlined /> Résultats et progression</span>}
              style={{ borderRadius: "16px", boxShadow: "0 4px 20px rgba(0, 0, 0, 0.08)", border: '1px solid #e9ecef' }}
            >
              {progress && progress.length > 0 ? (
                <List
                  itemLayout="horizontal"
                  dataSource={progress}
                  renderItem={(item) => {
                    const pct = item.pct ?? 0;
                    const icon = pct >= 80 ? <CheckCircleTwoTone twoToneColor="#52c41a" /> : pct >= 50 ? <InfoCircleTwoTone twoToneColor="#faad14" /> : <CloseCircleTwoTone twoToneColor="#ff4d4f" />;
                    const color = pct >= 80 ? "green" : pct >= 50 ? "orange" : "red";

                    return (
                      <List.Item style={{ backgroundColor: "#fafafa", marginBottom: "20px", padding: "20px", borderRadius: "12px", boxShadow: "0 2px 8px rgba(0,0,0,0.06)", border: '1px solid #f0f0f0' }}>
                        <List.Item.Meta
                          avatar={icon}
                          title={<span style={{ fontWeight: "bold", color: "#333", fontSize: '16px' }}>Quiz N° : {item.quizId ?? "N/A"}</span>}
                          description={
                            <>
                              <Progress percent={pct} status={pct >= 80 ? "success" : pct >= 50 ? "active" : "exception"} strokeColor={color} style={{ marginBottom: '12px' }} />
                              <Tag color={color} style={{ fontSize: '13px', padding: '4px 8px' }}>{item.scoreObtained ?? 0}/{item.scoreTotal ?? 0} points</Tag>
                            </>
                          }
                        />
                      </List.Item>
                    );
                  }}
                />
              ) : (
                <div style={{ textAlign: "center", color: "#999", padding: '50px' }}>
                  <FileTextOutlined style={{ fontSize: '48px', marginBottom: '16px' }} />
                  <p>Aucune donnée de progression trouvée.</p>
                </div>
              )}
            </Card>
          </div>
        )}

        {renderQuizSummaryModal()}
      </div>
    </div>
  );
};

export default TestDeConnaissance;